<div class="p-4 md:p-6 max-w-6xl mx-auto">

  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px;">currency_exchange</mat-icon>
      Administración de Tasas
    </h1>
    <p style="color: #6b7280; font-size: 0.85rem; margin-top: 4px;">
      Gestiona las tasas de cambio y parámetros del sistema.
    </p>
  </div>

  <!-- Candado de edición (solo producción). Ver AdminEditPermissionsService -->
  <app-solo-lectura-banner *ngIf="!puedeEditar"
    detalle="La edición de tasas, operador activo y bancos está reservada al operador autorizado. Los rieles de Pagos Venezuela siguen disponibles.">
  </app-solo-lectura-banner>

  <!-- Loading: cada sección pinta su esqueleto mientras llega su dato (ver
       los ng-template «esqueleto*» al final). Con el panel ya pintado, una
       acción que recarga los valores solo muestra este aviso. -->
  <div *ngIf="loading && valoresFrontend" class="aviso-recargando" role="status">
    <mat-spinner diameter="18"></mat-spinner>
    <span>Actualizando valores&hellip;</span>
  </div>

  <!-- Error -->
  <div *ngIf="error"
    style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 12px; padding: 14px 18px; margin-bottom: 16px; display: flex; align-items: center; gap: 8px;">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #dc2626;">error</mat-icon>
    <span style="font-size: 0.85rem; font-weight: 600; color: #dc2626;">{{ error }}</span>
  </div>

  <!-- Contenido principal: cada sección se pinta con su propio dato -->
  <ng-container>
    <div class="flex flex-col gap-5">

      <!-- ══════════ Sección 1: Operador Activo ══════════ -->
      <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="valoresFrontend || loading">
        <div (click)="toggleSection('operador')" role="button" tabindex="0"
          [attr.aria-expanded]="expandedSections.has('operador')"
          (keydown.enter)="toggleSectionTecla('operador', $event)" (keydown.space)="toggleSectionTecla('operador', $event)"
          class="flex items-center justify-between p-4 xl:p-5 cursor-pointer seccion-titulo"
          [style.background]="expandedSections.has('operador') ? 'linear-gradient(135deg, #f0fdf4, #ecfdf5)' : 'white'">
          <div class="flex items-center gap-2 sm:gap-3 flex-wrap">
            <mat-icon style="color: #1C593D; font-size: 22px; width: 22px; height: 22px;">settings</mat-icon>
            <span style="font-size: 1rem; font-weight: 700; color: #374151;">Operador Activo</span>
            <span *ngIf="valoresFrontend; else esqueletoPildora" style="display: inline-flex; align-items: center; padding: 4px 12px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 20px; font-size: 0.8rem; font-weight: 800; color: #1C593D;">
              {{ valoresFrontend.data?.operadorActivo || 'No definido' }}
            </span>
            <span *ngIf="!expandedSections.has('operador')" class="resumen-seccion">{{ estadoDato(lastValoresRefresh, 5) }}</span>
            <span *ngIf="expandedSections.has('operador') && frescura(lastValoresRefresh, 5) as fr" class="frescura" [class.frescura--vieja]="!fr.alDia">{{ fr.texto }}</span>
          </div>
          <mat-icon aria-hidden="true" style="color: #6b7280; transition: transform 0.3s ease; flex: 0 0 auto;"
            [style.transform]="expandedSections.has('operador') ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
        <div class="px-4 pb-4 xl:px-5 xl:pb-5"
          [class.hidden]="!expandedSections.has('operador')">
          <ng-container *ngIf="valoresFrontend; else esqueletoOperador">

          <!-- Toggle buttons operador -->
          <div class="flex flex-wrap gap-3 justify-center mb-4 mt-2">
            <button type="button" (click)="cambiarOperador('MANUAL')"
              [disabled]="!puedeEditar || loading || isUpdating || valoresFrontend.data?.operadorActivo === 'MANUAL'"
              [style.background]="valoresFrontend.data?.operadorActivo === 'MANUAL' ? '#1C593D' : 'white'"
              [style.color]="valoresFrontend.data?.operadorActivo === 'MANUAL' ? 'white' : '#374151'"
              [style.border]="valoresFrontend.data?.operadorActivo === 'MANUAL' ? 'none' : '1px solid #d1d5db'"
              [style.opacity]="(!puedeEditar || loading || isUpdating) ? '0.5' : '1'"
              [style.cursor]="(!puedeEditar || loading || isUpdating || valoresFrontend.data?.operadorActivo === 'MANUAL') ? 'not-allowed' : 'pointer'"
              style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; border-radius: 10px; font-weight: 700; font-size: 0.85rem; transition: all 0.2s ease;">
              <mat-icon *ngIf="valoresFrontend.data?.operadorActivo === 'MANUAL'" style="font-size: 16px; width: 16px; height: 16px;">check</mat-icon>
              MANUAL
            </button>
            <button type="button" (click)="cambiarOperador('BINANCE')"
              [disabled]="!puedeEditar || loading || isUpdating || valoresFrontend.data?.operadorActivo === 'BINANCE'"
              [style.background]="valoresFrontend.data?.operadorActivo === 'BINANCE' ? '#1C593D' : 'white'"
              [style.color]="valoresFrontend.data?.operadorActivo === 'BINANCE' ? 'white' : '#374151'"
              [style.border]="valoresFrontend.data?.operadorActivo === 'BINANCE' ? 'none' : '1px solid #d1d5db'"
              [style.opacity]="(!puedeEditar || loading || isUpdating) ? '0.5' : '1'"
              [style.cursor]="(!puedeEditar || loading || isUpdating || valoresFrontend.data?.operadorActivo === 'BINANCE') ? 'not-allowed' : 'pointer'"
              style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; border-radius: 10px; font-weight: 700; font-size: 0.85rem; transition: all 0.2s ease;">
              <mat-icon *ngIf="valoresFrontend.data?.operadorActivo === 'BINANCE'" style="font-size: 16px; width: 16px; height: 16px;">check</mat-icon>
              BINANCE
            </button>
            <button type="button" (click)="cambiarOperador('CBPAY')"
              [disabled]="!puedeEditar || loading || isUpdating || valoresFrontend.data?.operadorActivo === 'CBPAY'"
              [style.background]="valoresFrontend.data?.operadorActivo === 'CBPAY' ? '#1C593D' : 'white'"
              [style.color]="valoresFrontend.data?.operadorActivo === 'CBPAY' ? 'white' : '#374151'"
              [style.border]="valoresFrontend.data?.operadorActivo === 'CBPAY' ? 'none' : '1px solid #d1d5db'"
              [style.opacity]="(!puedeEditar || loading || isUpdating) ? '0.5' : '1'"
              [style.cursor]="(!puedeEditar || loading || isUpdating || valoresFrontend.data?.operadorActivo === 'CBPAY') ? 'not-allowed' : 'pointer'"
              style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; border-radius: 10px; font-weight: 700; font-size: 0.85rem; transition: all 0.2s ease;">
              <mat-icon *ngIf="valoresFrontend.data?.operadorActivo === 'CBPAY'" style="font-size: 16px; width: 16px; height: 16px;">check</mat-icon>
              CBPAY
            </button>
          </div>

          <!-- Action buttons -->
          <div class="flex flex-col sm:flex-row gap-2 justify-center">
            <button type="button" (click)="abrirModalEditarOperador()"
              [disabled]="!puedeEditar || loading || isUpdating"
              [style.opacity]="(!puedeEditar || loading || isUpdating) ? '0.5' : '1'"
              [style.cursor]="(!puedeEditar || loading || isUpdating) ? 'not-allowed' : 'pointer'"
              class="w-full sm:w-auto"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
              onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">tune</mat-icon>
              Actualizar Tasa
            </button>
            <button type="button" (click)="copiarTasa()"
              [disabled]="loading || isUpdating"
              [style.opacity]="(loading || isUpdating) ? '0.5' : '1'"
              [style.cursor]="(loading || isUpdating) ? 'not-allowed' : 'pointer'"
              class="w-full sm:w-auto"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
              onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">content_copy</mat-icon>
              Copiar tasa
            </button>
          </div>
          </ng-container>
        </div>
      </div>

      <!-- ══════════ Sección 2: Bancos Venezolanos ══════════ -->
      <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="valoresRegistrados?.data || cargandoRegistrados">
        <div (click)="toggleSection('bancos')" role="button" tabindex="0"
          [attr.aria-expanded]="expandedSections.has('bancos')"
          (keydown.enter)="toggleSectionTecla('bancos', $event)" (keydown.space)="toggleSectionTecla('bancos', $event)"
          class="flex items-center justify-between p-4 xl:p-5 cursor-pointer seccion-titulo"
          [style.background]="expandedSections.has('bancos') ? 'linear-gradient(135deg, #eff6ff, #dbeafe)' : 'white'">
          <div class="flex items-center gap-2 sm:gap-3 flex-wrap min-w-0">
            <mat-icon style="color: #2563eb; font-size: 22px; width: 22px; height: 22px;">account_balance</mat-icon>
            <span style="font-size: 1rem; font-weight: 700; color: #374151;">Bancos Venezolanos (Binance)</span>
            <span *ngIf="!expandedSections.has('bancos') && alarmaMarkup" class="alarma-resumen">
              <mat-icon aria-hidden="true">warning</mat-icon>
              Markup sobre umbral
            </span>
            <span *ngIf="!expandedSections.has('bancos')" class="resumen-seccion">
              {{ bancosActivosCount }} {{ bancosActivosCount === 1 ? 'banco activo' : 'bancos activos' }} &middot; {{ estadoDato(lastValoresRefresh, 5) }}
            </span>
            <span *ngIf="expandedSections.has('bancos') && frescura(lastValoresRefresh, 5) as fr" class="frescura" [class.frescura--vieja]="!fr.alDia">{{ fr.texto }}</span>
          </div>
          <mat-icon aria-hidden="true" style="color: #6b7280; transition: transform 0.3s ease; flex: 0 0 auto;"
            [style.transform]="expandedSections.has('bancos') ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
        <div class="px-4 pb-4 xl:px-5 xl:pb-5"
          [class.hidden]="!expandedSections.has('bancos')">
          <ng-container *ngIf="valoresRegistrados && valoresRegistrados.data; else esqueletoBancos">

          <!-- Info pills -->
          <div class="flex flex-wrap gap-3 mb-4 mt-2">
            <div style="display: inline-flex; align-items: center; gap: 6px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; padding: 6px 12px;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #1C593D;">attach_money</mat-icon>
              <span style="font-size: 0.75rem; font-weight: 600; color: #1e5a3f;">USD/CLP spot</span>
              <span style="font-size: 0.8rem; font-weight: 800; color: #1C593D;">{{ valoresRegistrados.data.usdClp | number:'1.2-2':'es-CL' }}</span>
            </div>
            <div style="display: inline-flex; align-items: center; gap: 6px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 10px; padding: 6px 12px;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #2563eb;">show_chart</mat-icon>
              <span style="font-size: 0.75rem; font-weight: 600; color: #1e40af;">Promedio USDT/VES</span>
              <span style="font-size: 0.8rem; font-weight: 800; color: #2563eb;">{{ valoresRegistrados.data.binance.promedio | number:'1.2-2':'es-CL' }}</span>
            </div>
            <div style="display: inline-flex; align-items: center; gap: 6px; background: #f3f4f6; border: 1px solid #e5e7eb; border-radius: 10px; padding: 6px 12px;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #6b7280;">schedule</mat-icon>
              <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">{{ valoresRegistrados.data.binance.ultimaActualizacion | date:'short' }}</span>
            </div>

            <!-- Tasa que aplica Aguacate. Sale del mismo endpoint que el tile
                 «USDT/CLP Venta» del dashboard de operación. Si no llegó, este
                 chip y el de verificación no se pintan. -->
            <div *ngIf="tasaAguacate" style="display: inline-flex; align-items: center; gap: 6px; background: #f7fee7; border: 1px solid #d9f99d; border-radius: 10px; padding: 6px 12px;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #4d7c0f;">eco</mat-icon>
              <span style="font-size: 0.75rem; font-weight: 600; color: #3f6212;">USD/CLP aguacate</span>
              <span style="font-size: 0.8rem; font-weight: 800; color: #4d7c0f;">{{ tasaAguacate | number:'1.2-2':'es-CL' }}</span>
            </div>

            <!-- Verificación de markup: cuánto se despegó la tasa Aguacate del
                 spot, y si se pasó del umbral. -->
            <div *ngIf="verificacionMarkup as mk"
              [style.background]="mk.sobreUmbral ? '#fef2f2' : '#f0fdf4'"
              [style.border]="mk.sobreUmbral ? '1px solid #fecaca' : '1px solid #bbf7d0'"
              [matTooltip]="'Tasa aguacate / spot = ' + (mk.ratio | number:'1.5-5':'es-CL') + ' · umbral ' + (umbralMarkupRatio | number:'1.3-3':'es-CL') + (mk.sobreUmbral ? '' : ' · faltan ' + (mk.holguraClp | number:'1.2-2':'es-CL') + ' CLP para el techo')"
              matTooltipTouchGestures="off"
              style="display: inline-flex; align-items: center; gap: 6px; border-radius: 10px; padding: 6px 12px;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px;"
                [style.color]="mk.sobreUmbral ? '#b91c1c' : '#15803d'">
                {{ mk.sobreUmbral ? 'warning' : 'check_circle' }}
              </mat-icon>
              <span style="font-size: 0.75rem; font-weight: 600;"
                [style.color]="mk.sobreUmbral ? '#991b1b' : '#166534'">
                {{ mk.sobreUmbral ? 'Markup sobre umbral' : 'Markup dentro de umbral' }}
              </span>
              <span style="font-size: 0.8rem; font-weight: 800;"
                [style.color]="mk.sobreUmbral ? '#b91c1c' : '#15803d'">
                {{ mk.markupPct >= 0 ? '+' : '' }}{{ mk.markupPct | number:'1.2-2':'es-CL' }} %
              </span>
            </div>
          </div>

          <!-- Umbral y ratio, con el mismo peso visual que en la propuesta:
               el operador que ve un chip rojo necesita saber contra qué se
               comparó, sin pasar el mouse por encima. -->
          <div *ngIf="verificacionMarkup as mk"
            style="margin-top: 4px; padding-top: 16px; margin-bottom: 16px; border-top: 1px dashed #e5e7eb; display: grid; grid-template-columns: repeat(auto-fit, minmax(190px, 1fr)); gap: 12px;">

            <div style="background: #f0fdf4; border: 1px solid #dcfce7; border-radius: 10px; padding: 10px 14px;">
              <span style="display: flex; align-items: center; gap: 4px; font-size: 0.7rem; color: #6b7280; font-weight: 600;">
                Umbral de markup
                <button type="button" (click)="abrirModalUmbralMarkup()"
                  [disabled]="!puedeEditar"
                  [style.opacity]="puedeEditar ? '1' : '0.4'"
                  [style.cursor]="puedeEditar ? 'pointer' : 'not-allowed'"
                  [matTooltip]="puedeEditar ? 'Editar el umbral' : 'Solo el encargado de la tasa puede cambiarlo'"
                  matTooltipTouchGestures="off"
                  style="display: inline-flex; align-items: center; background: none; border: none; padding: 0; color: #1C593D;">
                  <mat-icon style="font-size: 14px; width: 14px; height: 14px;">edit</mat-icon>
                </button>
              </span>
              <div style="font-family: monospace; font-size: 1.15rem; font-weight: 700; color: #1C593D; margin-top: 2px;">
                {{ mk.umbral | number:'1.3-3':'es-CL' }}
              </div>
              <span style="font-size: 0.65rem; color: #9ca3af;">
                markup máximo {{ (mk.umbral - 1) * 100 | number:'1.2-2':'es-CL' }} % &middot; parámetro de backend
              </span>
            </div>

            <div style="background: #f0fdf4; border: 1px solid #dcfce7; border-radius: 10px; padding: 10px 14px;">
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600;">Ratio aguacate / spot</span>
              <div style="font-family: monospace; font-size: 1.15rem; font-weight: 700; margin-top: 2px;"
                [style.color]="mk.sobreUmbral ? '#b91c1c' : '#1C593D'">
                {{ mk.ratio | number:'1.5-5':'es-CL' }}
              </div>
              <span style="font-size: 0.65rem; color: #9ca3af;">
                {{ mk.markupPct >= 0 ? '+' : '' }}{{ mk.markupPct | number:'1.2-2':'es-CL' }} % sobre el spot
              </span>
            </div>

            <div [style.background]="mk.sobreUmbral ? '#fef2f2' : '#f0fdf4'"
              [style.borderColor]="mk.sobreUmbral ? '#fecaca' : '#dcfce7'"
              style="border-width: 1px; border-style: solid; border-radius: 10px; padding: 10px 14px;">
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600;">
                {{ mk.sobreUmbral ? 'Excedido' : 'Falta para el techo' }}
              </span>
              <div style="font-family: monospace; font-size: 1.15rem; font-weight: 700; margin-top: 2px;"
                [style.color]="mk.sobreUmbral ? '#b91c1c' : '#1C593D'">
                {{ (mk.sobreUmbral ? -mk.holguraClp : mk.holguraClp) | number:'1.2-2':'es-CL' }} CLP
              </div>
              <span style="font-size: 0.65rem; color: #9ca3af;">
                techo en {{ mk.spot * mk.umbral | number:'1.2-2':'es-CL' }}
              </span>
            </div>
          </div>

          <!-- Bank cards -->
          <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 mb-4">
            <!-- Banesco -->
            <div class="relative"
              (click)="toggleBanco('BANESCO')"
              [class.cursor-pointer]="puedeEditar && valoresFrontend?.data?.operadorActivo === 'BINANCE'"
              [class.cursor-not-allowed]="!puedeEditar || valoresFrontend?.data?.operadorActivo !== 'BINANCE'"
              [class.opacity-60]="!puedeEditar || valoresFrontend?.data?.operadorActivo !== 'BINANCE'">
              <div *ngIf="!esBancoActivo('BANESCO')"
                style="position: absolute; inset: 0; background: linear-gradient(135deg, #1f2937, #111827); opacity: 0.9; border-radius: 12px; z-index: 10; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <mat-icon style="font-size: 28px; width: 28px; height: 28px; color: white; margin-bottom: 4px;">lock</mat-icon>
                <span style="font-size: 0.9rem; font-weight: 700; color: white;">Banesco</span>
                <span style="font-size: 0.8rem; font-weight: 700; color: #f87171;">INACTIVO</span>
                <span *ngIf="valoresFrontend?.data?.operadorActivo === 'BINANCE'"
                  style="font-size: 0.7rem; color: #d1d5db; margin-top: 6px; padding: 4px 10px; background: rgba(107,114,128,0.4); border-radius: 20px;">
                  Toca para activar
                </span>
              </div>
              <div *ngIf="updatedBanks.has('banesco')"
                style="position: absolute; top: 30px; right: 8px; background: #16a34a; color: white; font-size: 0.7rem; font-weight: 700; padding: 2px 8px; border-radius: 20px; z-index: 20;">
                Actualizado
              </div>
              <div *ngIf="valoresFrontend?.data?.operadorActivo === 'BINANCE'"
                style="position: absolute; top: 8px; right: 8px; font-size: 0.65rem; font-weight: 700; padding: 2px 8px; border-radius: 20px; z-index: 20; color: white;"
                [style.background]="esBancoActivo('BANESCO') ? '#16a34a' : '#dc2626'">
                {{ esBancoActivo('BANESCO') ? 'Activo' : 'Inactivo' }}
              </div>
              <app-rate-value-card
                [bank]="'Banesco'"
                [imgUrl]="'assets/img/bancos/banesco.png'"
                [rateDestination]="valoresRegistrados.data.binance.bancos.banesco.toString()">
              </app-rate-value-card>
            </div>

            <!-- Mercantil -->
            <div class="relative"
              (click)="toggleBanco('MERCANTIL')"
              [class.cursor-pointer]="puedeEditar && valoresFrontend?.data?.operadorActivo === 'BINANCE'"
              [class.cursor-not-allowed]="!puedeEditar || valoresFrontend?.data?.operadorActivo !== 'BINANCE'"
              [class.opacity-60]="!puedeEditar || valoresFrontend?.data?.operadorActivo !== 'BINANCE'">
              <div *ngIf="!esBancoActivo('MERCANTIL')"
                style="position: absolute; inset: 0; background: linear-gradient(135deg, #1f2937, #111827); opacity: 0.9; border-radius: 12px; z-index: 10; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <mat-icon style="font-size: 28px; width: 28px; height: 28px; color: white; margin-bottom: 4px;">lock</mat-icon>
                <span style="font-size: 0.9rem; font-weight: 700; color: white;">Mercantil</span>
                <span style="font-size: 0.8rem; font-weight: 700; color: #f87171;">INACTIVO</span>
                <span *ngIf="valoresFrontend?.data?.operadorActivo === 'BINANCE'"
                  style="font-size: 0.7rem; color: #d1d5db; margin-top: 6px; padding: 4px 10px; background: rgba(107,114,128,0.4); border-radius: 20px;">
                  Toca para activar
                </span>
              </div>
              <div *ngIf="updatedBanks.has('mercantil')"
                style="position: absolute; top: 30px; right: 8px; background: #16a34a; color: white; font-size: 0.7rem; font-weight: 700; padding: 2px 8px; border-radius: 20px; z-index: 20;">
                Actualizado
              </div>
              <div *ngIf="valoresFrontend?.data?.operadorActivo === 'BINANCE'"
                style="position: absolute; top: 8px; right: 8px; font-size: 0.65rem; font-weight: 700; padding: 2px 8px; border-radius: 20px; z-index: 20; color: white;"
                [style.background]="esBancoActivo('MERCANTIL') ? '#16a34a' : '#dc2626'">
                {{ esBancoActivo('MERCANTIL') ? 'Activo' : 'Inactivo' }}
              </div>
              <app-rate-value-card
                [bank]="'Mercantil'"
                [imgUrl]="'assets/img/bancos/mercantil.png'"
                [rateDestination]="valoresRegistrados.data.binance.bancos.mercantil.toString()">
              </app-rate-value-card>
            </div>

            <!-- Provincial -->
            <div class="relative"
              (click)="toggleBanco('PROVINCIAL')"
              [class.cursor-pointer]="puedeEditar && valoresFrontend?.data?.operadorActivo === 'BINANCE'"
              [class.cursor-not-allowed]="!puedeEditar || valoresFrontend?.data?.operadorActivo !== 'BINANCE'"
              [class.opacity-60]="!puedeEditar || valoresFrontend?.data?.operadorActivo !== 'BINANCE'">
              <div *ngIf="!esBancoActivo('PROVINCIAL')"
                style="position: absolute; inset: 0; background: linear-gradient(135deg, #1f2937, #111827); opacity: 0.9; border-radius: 12px; z-index: 10; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <mat-icon style="font-size: 28px; width: 28px; height: 28px; color: white; margin-bottom: 4px;">lock</mat-icon>
                <span style="font-size: 0.9rem; font-weight: 700; color: white;">Provincial</span>
                <span style="font-size: 0.8rem; font-weight: 700; color: #f87171;">INACTIVO</span>
                <span *ngIf="valoresFrontend?.data?.operadorActivo === 'BINANCE'"
                  style="font-size: 0.7rem; color: #d1d5db; margin-top: 6px; padding: 4px 10px; background: rgba(107,114,128,0.4); border-radius: 20px;">
                  Toca para activar
                </span>
              </div>
              <div *ngIf="updatedBanks.has('provincial')"
                style="position: absolute; top: 30px; right: 8px; background: #16a34a; color: white; font-size: 0.7rem; font-weight: 700; padding: 2px 8px; border-radius: 20px; z-index: 20;">
                Actualizado
              </div>
              <div *ngIf="valoresFrontend?.data?.operadorActivo === 'BINANCE'"
                style="position: absolute; top: 8px; right: 8px; font-size: 0.65rem; font-weight: 700; padding: 2px 8px; border-radius: 20px; z-index: 20; color: white;"
                [style.background]="esBancoActivo('PROVINCIAL') ? '#16a34a' : '#dc2626'">
                {{ esBancoActivo('PROVINCIAL') ? 'Activo' : 'Inactivo' }}
              </div>
              <app-rate-value-card
                [bank]="'Provincial'"
                [imgUrl]="'assets/img/bancos/provincial.png'"
                [rateDestination]="valoresRegistrados.data.binance.bancos.provincial.toString()">
              </app-rate-value-card>
            </div>

            <!-- Venezuela -->
            <div class="relative"
              (click)="toggleBanco('VENEZUELA')"
              [class.cursor-pointer]="puedeEditar && valoresFrontend?.data?.operadorActivo === 'BINANCE'"
              [class.cursor-not-allowed]="!puedeEditar || valoresFrontend?.data?.operadorActivo !== 'BINANCE'"
              [class.opacity-60]="!puedeEditar || valoresFrontend?.data?.operadorActivo !== 'BINANCE'">
              <div *ngIf="!esBancoActivo('VENEZUELA')"
                style="position: absolute; inset: 0; background: linear-gradient(135deg, #1f2937, #111827); opacity: 0.9; border-radius: 12px; z-index: 10; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <mat-icon style="font-size: 28px; width: 28px; height: 28px; color: white; margin-bottom: 4px;">lock</mat-icon>
                <span style="font-size: 0.9rem; font-weight: 700; color: white;">Venezuela</span>
                <span style="font-size: 0.8rem; font-weight: 700; color: #f87171;">INACTIVO</span>
                <span *ngIf="valoresFrontend?.data?.operadorActivo === 'BINANCE'"
                  style="font-size: 0.7rem; color: #d1d5db; margin-top: 6px; padding: 4px 10px; background: rgba(107,114,128,0.4); border-radius: 20px;">
                  Toca para activar
                </span>
              </div>
              <div *ngIf="updatedBanks.has('venezuela')"
                style="position: absolute; top: 30px; right: 8px; background: #16a34a; color: white; font-size: 0.7rem; font-weight: 700; padding: 2px 8px; border-radius: 20px; z-index: 20;">
                Actualizado
              </div>
              <div *ngIf="valoresFrontend?.data?.operadorActivo === 'BINANCE'"
                style="position: absolute; top: 8px; right: 8px; font-size: 0.65rem; font-weight: 700; padding: 2px 8px; border-radius: 20px; z-index: 20; color: white;"
                [style.background]="esBancoActivo('VENEZUELA') ? '#16a34a' : '#dc2626'">
                {{ esBancoActivo('VENEZUELA') ? 'Activo' : 'Inactivo' }}
              </div>
              <app-rate-value-card
                [bank]="'Venezuela'"
                [imgUrl]="'assets/img/bancos/venezuela.png'"
                [rateDestination]="valoresRegistrados.data.binance.bancos.venezuela.toString()">
              </app-rate-value-card>
            </div>
          </div>

          <!-- Otros operadores -->
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 14px;">
              <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 6px;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">payments</mat-icon>
                <span style="font-size: 0.8rem; font-weight: 600; color: #1e5a3f;">CBPAY</span>
              </div>
              <span style="font-size: 1.2rem; font-weight: 800; color: #1C593D;">{{ valoresRegistrados.data.cbpay.valor | number:'1.2-2':'es-CL' }}</span>
            </div>
            <div style="background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 12px; padding: 14px;">
              <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 6px;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">edit</mat-icon>
                <span style="font-size: 0.8rem; font-weight: 600; color: #1e40af;">Manual</span>
              </div>
              <span style="font-size: 1.2rem; font-weight: 800; color: #2563eb;">{{ valoresRegistrados.data.manual.valor | number:'1.2-2':'es-CL' }}</span>
            </div>
          </div>
          </ng-container>
        </div>
      </div>

      <!-- ══════════ Sección 3: Tasa web del día ══════════ -->
      <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="(tasas && tasas.length >= 3) || (loading && !valoresFrontend)">
        <div (click)="toggleSection('tasaWeb')" role="button" tabindex="0"
          [attr.aria-expanded]="expandedSections.has('tasaWeb')"
          (keydown.enter)="toggleSectionTecla('tasaWeb', $event)" (keydown.space)="toggleSectionTecla('tasaWeb', $event)"
          class="flex items-center justify-between p-4 xl:p-5 cursor-pointer seccion-titulo"
          [style.background]="expandedSections.has('tasaWeb') ? 'linear-gradient(135deg, #faf5ff, #f3e8ff)' : 'white'">
          <div class="flex items-center gap-1 sm:gap-2 flex-wrap min-w-0">
            <span style="font-size: 1rem; font-weight: 700; color: #374151;">Tasa web del día</span>
            <img src="assets/flags/chile.png" alt="Chile" style="width: 24px; height: 24px; border-radius: 50%; object-fit: cover; border: 1px solid #e5e7eb;">
            <span style="font-size: 1rem; font-weight: 700; color: #374151;">CLP -></span>
            <img src="assets/flags/venezuela.png" alt="Venezuela" style="width: 24px; height: 24px; border-radius: 50%; object-fit: cover; border: 1px solid #e5e7eb;">
            <span style="font-size: 1rem; font-weight: 700; color: #374151;">VES</span>
            <span *ngIf="!expandedSections.has('tasaWeb') && tasas.length >= 3" class="resumen-seccion">
              {{ (tramosWebClpVes || (tasas | slice:0:3)).length }} franjas &middot; {{ aplicandoFranjas.has('CLP-VES') ? 'aplicando tu cambio…' : estadoDato(lastValoresRefresh, 5) }}
            </span>
            <span *ngIf="expandedSections.has('tasaWeb') && aplicandoFranjas.has('CLP-VES')" class="frescura frescura--vieja">Aplicando tu cambio&hellip;</span>
            <span *ngIf="expandedSections.has('tasaWeb') && !aplicandoFranjas.has('CLP-VES') && frescura(lastValoresRefresh, 5) as fr" class="frescura" [class.frescura--vieja]="!fr.alDia">{{ fr.texto }}</span>
          </div>
          <mat-icon aria-hidden="true" style="color: #6b7280; transition: transform 0.3s ease; flex: 0 0 auto;"
            [style.transform]="expandedSections.has('tasaWeb') ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
        <div class="px-4 pb-4 xl:px-5 xl:pb-5"
          [class.hidden]="!expandedSections.has('tasaWeb')">
          <div *ngIf="tasas.length >= 3; else esqueletoTarjetas" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-2">
            <div *ngFor="let tasa of (tramosWebClpVes || (tasas | slice:0:3)); let i = index" class="relative"
              style="background: white; border: 1px solid #e5e7eb; border-radius: 12px; padding: 16px; text-align: center;">
              <div *ngIf="!tramosWebClpVes && updatedIndexes.has(i)"
                style="position: absolute; top: 8px; right: 8px; background: #16a34a; color: white; font-size: 0.65rem; font-weight: 700; padding: 2px 8px; border-radius: 20px;">
                Actualizado
              </div>
              <p style="font-size: 0.8rem; font-weight: 700; color: #1C593D; overflow-wrap: anywhere; margin-bottom: 4px;">
                {{ tasa.etiqueta ? tasa.etiqueta : ((tasa.rango?.split('-')[0] | currency:'USD':'$':'1.0-0':'es-CL') + ' CLP - ' + (tasa.rango?.split('-')[1] | currency:'USD':'$':'1.0-0':'es-CL') + ' CLP') }}
              </p>
              <p style="font-size: 0.75rem; color: #6b7280; margin-bottom: 4px;">{{ tasa.descripcion }}</p>
              <p style="font-size: 1.1rem; font-weight: 800; color: #1C593D;">Tasa: {{ tasa.tasa | number:'1.4-4':'es-CL' }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- ══════════ Sección 3b: Tasa web del día VES -> CLP ══════════ -->
      <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="(tasasVesClp && tasasVesClp.length >= (tramosVesClpDinamicos ? 1 : 3)) || (cargandoVesClp && !tasasVesClp.length)">
        <div (click)="toggleSection('tasaWebVesClp')" role="button" tabindex="0"
          [attr.aria-expanded]="expandedSections.has('tasaWebVesClp')"
          (keydown.enter)="toggleSectionTecla('tasaWebVesClp', $event)" (keydown.space)="toggleSectionTecla('tasaWebVesClp', $event)"
          class="flex items-center justify-between p-4 xl:p-5 cursor-pointer seccion-titulo"
          [style.background]="expandedSections.has('tasaWebVesClp') ? 'linear-gradient(135deg, #faf5ff, #f3e8ff)' : 'white'">
          <div class="flex items-center gap-1 sm:gap-2 flex-wrap min-w-0">
            <span style="font-size: 1rem; font-weight: 700; color: #374151;">Tasa web del día</span>
            <img src="assets/flags/venezuela.png" alt="Venezuela" style="width: 24px; height: 24px; border-radius: 50%; object-fit: cover; border: 1px solid #e5e7eb;">
            <span style="font-size: 1rem; font-weight: 700; color: #374151;">VES -></span>
            <img src="assets/flags/chile.png" alt="Chile" style="width: 24px; height: 24px; border-radius: 50%; object-fit: cover; border: 1px solid #e5e7eb;">
            <span style="font-size: 1rem; font-weight: 700; color: #374151;">CLP</span>
            <span *ngIf="!expandedSections.has('tasaWebVesClp') && tasasVesClp.length" class="resumen-seccion">
              {{ tasasVesClp.length }} franjas &middot; {{ aplicandoFranjas.has('VES-CLP') ? 'aplicando tu cambio…' : estadoDato(lastVesClpRefresh, 5) }}
            </span>
            <span *ngIf="expandedSections.has('tasaWebVesClp') && aplicandoFranjas.has('VES-CLP')" class="frescura frescura--vieja">Aplicando tu cambio&hellip;</span>
            <span *ngIf="expandedSections.has('tasaWebVesClp') && !aplicandoFranjas.has('VES-CLP') && frescura(lastVesClpRefresh, 5) as fr" class="frescura" [class.frescura--vieja]="!fr.alDia">{{ fr.texto }}</span>
          </div>
          <mat-icon aria-hidden="true" style="color: #6b7280; transition: transform 0.3s ease; flex: 0 0 auto;"
            [style.transform]="expandedSections.has('tasaWebVesClp') ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
        <div class="px-4 pb-4 xl:px-5 xl:pb-5"
          [class.hidden]="!expandedSections.has('tasaWebVesClp')">
          <div *ngIf="tasasVesClp.length; else esqueletoTarjetas" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-2">
            <div *ngFor="let tasa of tasasVesClp; let i = index" class="relative"
              style="background: white; border: 1px solid #e5e7eb; border-radius: 12px; padding: 16px; text-align: center;">
              <div *ngIf="updatedVesClpIndexes.has(i)"
                style="position: absolute; top: 8px; right: 8px; background: #16a34a; color: white; font-size: 0.65rem; font-weight: 700; padding: 2px 8px; border-radius: 20px;">
                Actualizado
              </div>
              <p style="font-size: 0.8rem; font-weight: 700; color: #1C593D; overflow-wrap: anywhere; margin-bottom: 4px;">
                {{ tasa.etiqueta ? tasa.etiqueta : ((tasa.rango?.split('-')[0] | currency:'USD':'$':'1.0-0':'es-CL') + ' CLP - ' + (tasa.rango?.split('-')[1] | currency:'USD':'$':'1.0-0':'es-CL') + ' CLP') }}
              </p>
              <p style="font-size: 0.75rem; color: #6b7280; margin-bottom: 4px;">{{ tasa.descripcion }}</p>
              <p style="font-size: 1.1rem; font-weight: 800; color: #1C593D;">Tasa: {{ tasa.tasa | number:'1.4-4':'es-CL' }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- ══════════ Sección 3c: Franjas CLP ↔ VES (editor) ══════════ -->
      <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
        <div (click)="toggleSection('franjas')" role="button" tabindex="0"
          [attr.aria-expanded]="expandedSections.has('franjas')"
          (keydown.enter)="toggleSectionTecla('franjas', $event)" (keydown.space)="toggleSectionTecla('franjas', $event)"
          class="flex items-center justify-between p-4 xl:p-5 cursor-pointer seccion-titulo"
          [style.background]="expandedSections.has('franjas') ? 'linear-gradient(135deg, #f0fdf4, #ecfdf5)' : 'white'">
          <div class="flex items-center gap-2 sm:gap-3 flex-wrap min-w-0">
            <mat-icon style="color: #1C593D; font-size: 22px; width: 22px; height: 22px;">stacked_bar_chart</mat-icon>
            <span style="font-size: 1rem; font-weight: 700; color: #374151;">Franjas CLP ↔ VES</span>
            <span *ngIf="!expandedSections.has('franjas') && resumenFranjas?.length" class="resumen-seccion">
              <ng-container *ngFor="let r of resumenFranjas; let last = last">{{ r.par === 'CLP-VES' ? 'CLP → VES' : 'VES → CLP' }} {{ r.franjas }} {{ r.franjas === 1 ? 'franja' : 'franjas' }}<ng-container *ngIf="!last"> &middot; </ng-container></ng-container>
              &middot; {{ aplicandoFranjas.size ? 'aplicando tu cambio…' : 'al día' }}
            </span>
            <span *ngIf="!resumenFranjasOk && !cargandoResumenFranjas" class="frescura frescura--vieja">sin datos</span>
          </div>
          <mat-icon aria-hidden="true" style="color: #6b7280; transition: transform 0.3s ease; flex: 0 0 auto;"
            [style.transform]="expandedSections.has('franjas') ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
        <div [class.hidden]="!expandedSections.has('franjas')">
        <div *ngIf="cargandoResumenFranjas && !resumenFranjas" class="px-4 pb-4 xl:px-5 xl:pb-5">
          <ng-container *ngTemplateOutlet="esqueletoTarjetas; context: { $implicit: 2 }"></ng-container>
        </div>
        <div *ngIf="resumenFranjas?.length" class="grid grid-cols-1 sm:grid-cols-2 gap-3 px-4 pb-4 xl:px-5 xl:pb-5">
          <div *ngFor="let r of resumenFranjas"
            style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 12px;">
            <div class="flex items-center gap-2" style="margin-bottom: 4px;">
              <span style="font-size: 0.85rem; font-weight: 800; color: #1C593D;">{{ r.par === 'CLP-VES' ? 'CLP → VES' : 'VES → CLP' }}</span>
              <span *ngIf="r.respaldo"
                style="padding: 1px 8px; border-radius: 20px; font-size: 0.68rem; font-weight: 800; background: #fffbeb; border: 1px solid #fde68a; color: #b45309;">
                Respaldo
              </span>
            </div>
            <p style="font-size: 0.8rem; color: #374151;">
              {{ r.franjas }} {{ r.franjas === 1 ? 'franja' : 'franjas' }}
              <span *ngIf="r.min != null && r.max != null" style="color: #6b7280;">
                · {{ r.min | number:'1.0-0':'es-CL' }} a {{ r.max | number:'1.0-0':'es-CL' }} CLP
              </span>
            </p>
            <p style="margin-top: 6px;">
              <span *ngIf="aplicandoFranjas.has(r.par)" class="frescura frescura--vieja">Aplicando tu cambio&hellip;</span>
              <span *ngIf="!aplicandoFranjas.has(r.par) && resumenFranjasOk" class="frescura">Al día</span>
              <span *ngIf="!aplicandoFranjas.has(r.par) && !resumenFranjasOk" class="frescura frescura--vieja">Sin datos</span>
            </p>
          </div>
        </div>
        <!-- Ver: cualquier operador (sin permiso abre en «Solo lectura»). Editar: solo los encargados. -->
        <div class="acciones-tasas px-4 pb-4 xl:px-5 xl:pb-5">
          <button type="button" class="btn-tasas btn-tasas--ver" (click)="abrirFranjas()">
            <mat-icon aria-hidden="true">visibility</mat-icon>
            Ver franjas e historial
          </button>
          <button type="button" class="btn-tasas btn-tasas--editar" (click)="abrirFranjas()"
            [disabled]="!puedeEditarFranjas" [attr.aria-describedby]="puedeEditarFranjas ? null : 'motivo-franjas'">
            <mat-icon aria-hidden="true">{{ puedeEditarFranjas ? 'tune' : 'lock' }}</mat-icon>
            Editar
          </button>
          <span *ngIf="!puedeEditarFranjas" id="motivo-franjas" class="motivo-sin-permiso">{{ textoSinPermisoTasas }}</span>
        </div>
        </div>
      </div>

      <!-- ══════════ Sección 4: Tasa USDT → VES (Compacta) ══════════ -->
      <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden relative">
        <div *ngIf="usdtVesUpdated"
          style="position: absolute; top: 12px; right: 48px; background: #16a34a; color: white; font-size: 0.7rem; font-weight: 700; padding: 2px 8px; border-radius: 20px; z-index: 20;">
          Actualizado
        </div>
        <div (click)="toggleSection('usdtVes')" role="button" tabindex="0"
          [attr.aria-expanded]="expandedSections.has('usdtVes')"
          (keydown.enter)="toggleSectionTecla('usdtVes', $event)" (keydown.space)="toggleSectionTecla('usdtVes', $event)"
          class="flex items-center justify-between p-4 xl:p-5 cursor-pointer seccion-titulo"
          [style.background]="expandedSections.has('usdtVes') ? 'linear-gradient(135deg, #fffbeb, #fef3c7)' : 'white'">
          <div class="flex items-center gap-2 sm:gap-3 flex-wrap">
            <mat-icon style="color: #f59e0b; font-size: 22px; width: 22px; height: 22px;">swap_vert</mat-icon>
            <span style="font-size: 1rem; font-weight: 700; color: #374151;">Tasa USDT &rarr; VES</span>
            <ng-container *ngIf="!usdtVesConfig && loadingUsdtVes">
              <ng-container *ngTemplateOutlet="esqueletoPildora"></ng-container>
            </ng-container>
            <span *ngIf="usdtVesConfig?.data?.tasaVigente && !expandedSections.has('usdtVes')"
              style="display: inline-flex; align-items: center; padding: 4px 12px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 20px; font-size: 0.8rem; font-weight: 800; color: #1C593D;">
              {{ usdtVesConfig?.data?.tasaVigente?.tasaFinal | number:'1.2-2':'es-CL' }} VES
            </span>
            <span *ngIf="!expandedSections.has('usdtVes') && alarmaDesvioUsdtVes" class="alarma-resumen">
              <mat-icon aria-hidden="true">trending_down</mat-icon>
              Desvío en contra: {{ desvioUsdtVes!.pct | number:'1.2-2':'es-CL' }} %
            </span>
            <span *ngIf="!expandedSections.has('usdtVes')" class="resumen-seccion">{{ estadoDato(lastUsdtVesRefresh, 3) }} &middot; precios Binance en pausa</span>
            <span *ngIf="expandedSections.has('usdtVes') && frescura(lastUsdtVesRefresh, 3) as fr" class="frescura" [class.frescura--vieja]="!fr.alDia">{{ fr.texto }}</span>
          </div>
          <mat-icon aria-hidden="true" style="color: #6b7280; transition: transform 0.3s ease; flex: 0 0 auto;"
            [style.transform]="expandedSections.has('usdtVes') ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
        <div class="px-4 pb-4 xl:px-5 xl:pb-5"
          [class.hidden]="!expandedSections.has('usdtVes')">

          <!-- Loading -->
          <ng-container *ngIf="loadingUsdtVes && !usdtVesConfig">
            <ng-container *ngTemplateOutlet="esqueletoBloque"></ng-container>
          </ng-container>

          <div *ngIf="usdtVesConfig">
            <!-- Tasa vigente prominente -->
            <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border: 2px solid #bbf7d0; border-radius: 14px; padding: 20px; margin-bottom: 12px; margin-top: 8px; text-align: center;">
              <p style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; color: #16a34a; font-weight: 600; margin-bottom: 6px;">Tasa Vigente (Descuento)</p>
              <p style="font-size: 2.2rem; font-weight: 800; color: #1C593D; line-height: 1;">
                {{ usdtVesConfig.data.tasaVigente?.tasaFinal | number:'1.2-2':'es-CL' }}
                <span style="font-size: 1rem; font-weight: 600; color: #16a34a;">VES</span>
              </p>
              <p style="font-size: 0.75rem; color: #6b7280; margin-top: 4px;">por 1 USDT</p>
              <!-- Cuál de los dos números manda: sin esto la card muestra dos
                   tasas y no dice cuál es la que se cobra. -->
              <div style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 8px; flex-wrap: wrap;">
                <span style="display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; background: #dcfce7; border: 1px solid #86efac; border-radius: 9999px; font-size: 0.68rem; font-weight: 800; letter-spacing: 0.5px; color: #166534;">
                  APLICADA
                </span>
                <span style="font-size: 0.7rem; color: #6b7280;">es la que cobran las calculadoras</span>
                <span *ngIf="lastUsdtVesRefresh" style="font-size: 0.7rem; color: #9ca3af;">&middot; le&iacute;da {{ hace(lastUsdtVesRefresh) }}</span>
                <button type="button" (click)="cargarUsdtVesConfig()" title="Actualizar ahora" aria-label="Actualizar ahora"
                  style="display: inline-flex; align-items: center; background: none; border: none; padding: 0; cursor: pointer; color: #16a34a;">
                  <mat-icon style="font-size: 15px; width: 15px; height: 15px;">refresh</mat-icon>
                </button>
              </div>
              <!-- La cuenta, escrita. Es la que el operador hace a mano para
                   controlar que la tasa sea la que configuró. -->
              <div style="margin-top: 12px; padding-top: 10px; border-top: 1px dashed #bbf7d0;">
                <p style="font-size: 0.85rem; color: #374151; line-height: 1.6;">
                  Binance <b style="font-weight: 700;">{{ usdtVesConfig.data.datosEnVivo.promedioBinanceActual | number:'1.2-2':'es-CL' }}</b>
                  <span style="color: #6b7280;"> &minus; comisi&oacute;n </span>
                  <b style="font-weight: 700; color: #f59e0b;">{{ usdtVesConfig.data.datosEnVivo.comisionConfigurada | number:'1.0-2':'es-CL' }} %</b>
                  <span style="color: #6b7280;"> = </span>
                  <b style="font-weight: 800; color: #1C593D;">{{ usdtVesConfig.data.datosEnVivo.tasaFinalCalculada | number:'1.2-2':'es-CL' }} VES</b>
                </p>
                <p style="font-size: 0.7rem; color: #6b7280; margin-top: 2px;">
                  Esta cuenta se rehace cada vez que un cliente cotiza.
                </p>
              </div>
            </div>

            <!-- Modo activo -->
            <div *ngIf="usdtVesConfig.data.tasaVigente" style="text-align: center; margin-bottom: 12px;">
              <span
                [style.background]="usdtVesConfig.data.tasaVigente.modo === 'MANUAL_FIJO' ? '#fef3c7' : '#dcfce7'"
                [style.color]="usdtVesConfig.data.tasaVigente.modo === 'MANUAL_FIJO' ? '#92400e' : '#166534'"
                style="display: inline-flex; align-items: center; gap: 4px; padding: 3px 12px; border-radius: 9999px; font-size: 0.72rem; font-weight: 700;">
                Modo activo: {{ usdtVesConfig.data.tasaVigente.modo === 'MANUAL_FIJO' ? 'Precio manual fijo' : 'Automático por comisión %' }}
              </span>
            </div>

            <!-- Confirmación explícita. Carlos pidió ver que la tasa que se
                 cobra sea la de la regla; la ausencia de alarma no alcanza. -->
            <div *ngIf="!usdtVesConfig.data.hayCambios"
              style="display: flex; align-items: center; justify-content: center; gap: 6px; margin-bottom: 12px;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">check_circle</mat-icon>
              <span style="font-size: 0.78rem; font-weight: 600; color: #166534;">
                Lo que se cobra es exactamente lo que dice la comisi&oacute;n configurada.
              </span>
            </div>

            <!-- Desvío entre lo que se cobra y lo que dice la regla. Lo primero
                 que se lee es para qué lado se va la plata, no el número. -->
            <div *ngIf="usdtVesConfig.data.hayCambios && desvioUsdtVes"
              [style.background]="desvioUsdtVes!.aFavor ? '#f0fdf4' : '#fef2f2'"
              [style.borderColor]="desvioUsdtVes!.aFavor ? '#bbf7d0' : '#fecaca'"
              style="border: 1px solid; border-radius: 12px; padding: 14px; margin-bottom: 12px;">

              <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
                <mat-icon [style.color]="desvioUsdtVes!.aFavor ? '#16a34a' : '#dc2626'"
                  style="font-size: 18px; width: 18px; height: 18px;">
                  {{ desvioUsdtVes!.aFavor ? 'trending_up' : 'trending_down' }}
                </mat-icon>
                <span [style.color]="desvioUsdtVes!.aFavor ? '#166534' : '#991b1b'"
                  style="font-size: 0.9rem; font-weight: 800;">
                  {{ desvioUsdtVes!.pct | number:'1.2-2':'es-CL' }} %
                  {{ desvioUsdtVes!.aFavor ? 'a favor de Aguacate' : 'en contra de Aguacate' }}
                </span>
              </div>

              <div style="display: grid; grid-template-columns: auto 1fr; gap: 4px 12px; font-size: 0.8rem; margin-bottom: 10px;">
                <span style="color: #6b7280;">Se cobra</span>
                <b style="color: #374151;">{{ desvioUsdtVes!.cobra | number:'1.2-2':'es-CL' }} VES</b>
                <span style="color: #6b7280;">La regla da</span>
                <b style="color: #374151;">{{ desvioUsdtVes!.regla | number:'1.2-2':'es-CL' }} VES</b>
                <span style="color: #6b7280;">Por 100 USDT</span>
                <b [style.color]="desvioUsdtVes!.aFavor ? '#166534' : '#991b1b'">
                  el cliente recibe {{ desvioUsdtVes!.difPor100 | number:'1.0-0':'es-CL' }} VES
                  {{ desvioUsdtVes!.aFavor ? 'menos' : 'm&aacute;s' }}
                </b>
              </div>

              <p style="font-size: 0.72rem; color: #6b7280; margin-bottom: 10px; line-height: 1.5;">
                Con la tasa calcul&aacute;ndose al cotizar esto no deber&iacute;a pasar. Guard&aacute; para
                dejarlas parejas y avis&aacute; a desarrollo.
              </p>
              <button type="button" (click)="actualizarTasaUsdtVesAhora()"
                [disabled]="!puedeEditarTasas || loading || isUpdating"
                [style.opacity]="(!puedeEditarTasas || loading || isUpdating) ? '0.5' : '1'"
                [style.cursor]="(!puedeEditarTasas || loading || isUpdating) ? 'not-allowed' : 'pointer'"
                class="w-full sm:w-auto"
                style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 20px; background: #f59e0b; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: background 0.2s ease;"
                onmouseover="this.style.background='#d97706'" onmouseout="this.style.background='#f59e0b'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">save</mat-icon>
                Guardar tasa en vivo
              </button>
            </div>

            <!-- Dónde está cada precio: Binance P2P, costo, base, tramos y el otro sentido -->
            <app-precio-binance-bloque direccion="USDT-VES" [activo]="expandedSections.has('usdtVes')"
              [config]="usdtVesConfig" [configContraria]="vesUsdtConfig" [puedeEditar]="puedeEditarFranjas">
            </app-precio-binance-bloque>

            <!-- Tramos USDT → VES: ver para todos, editar solo los encargados -->
            <div class="acciones-tasas acciones-tasas--centro" style="margin-bottom: 10px;">
              <button type="button" class="btn-tasas btn-tasas--ver" (click)="abrirFranjas('USDT-VES')">
                <mat-icon aria-hidden="true">visibility</mat-icon>
                Ver tramos e historial
              </button>
              <button type="button" class="btn-tasas btn-tasas--editar" (click)="abrirFranjas('USDT-VES')"
                [disabled]="!puedeEditarFranjas" [attr.aria-describedby]="puedeEditarFranjas ? null : 'motivo-tramos-usdt-ves'">
                <mat-icon aria-hidden="true">{{ puedeEditarFranjas ? 'stacked_bar_chart' : 'lock' }}</mat-icon>
                Editar tramos
              </button>
              <span *ngIf="!puedeEditarFranjas" id="motivo-tramos-usdt-ves" class="motivo-sin-permiso">{{ textoSinPermisoTasas }}</span>
            </div>

            <!-- Botón configurar -->
            <div class="flex justify-center">
              <button type="button" (click)="abrirModalUsdtVes()"
                [disabled]="!puedeEditarTasas || loading || isUpdating"
                [style.opacity]="(!puedeEditarTasas || loading || isUpdating) ? '0.5' : '1'"
                [style.cursor]="(!puedeEditarTasas || loading || isUpdating) ? 'not-allowed' : 'pointer'"
                class="w-full sm:w-auto"
                style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 10px 28px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">settings</mat-icon>
                Configurar Comisi&oacute;n USDT/VES
              </button>
            </div>
          </div>

          <!-- Error USDT-VES -->
          <div *ngIf="errorUsdtVes"
            style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 12px; padding: 14px; text-align: center; margin-top: 8px;">
            <p style="font-size: 0.85rem; color: #dc2626; font-weight: 600; margin-bottom: 10px;">{{ errorUsdtVes }}</p>
            <button type="button" (click)="cargarUsdtVesConfig()"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 20px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: background 0.2s ease;"
              onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">refresh</mat-icon>
              Reintentar
            </button>
          </div>
        </div>
      </div>

      <!-- ══════════ Sección 5: Tasa VES → USDT (Compacta) ══════════ -->
      <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden relative">
        <div *ngIf="vesUsdtUpdated"
          style="position: absolute; top: 12px; right: 48px; background: #16a34a; color: white; font-size: 0.7rem; font-weight: 700; padding: 2px 8px; border-radius: 20px; z-index: 20;">
          Actualizado
        </div>
        <div (click)="toggleSection('vesUsdt')" role="button" tabindex="0"
          [attr.aria-expanded]="expandedSections.has('vesUsdt')"
          (keydown.enter)="toggleSectionTecla('vesUsdt', $event)" (keydown.space)="toggleSectionTecla('vesUsdt', $event)"
          class="flex items-center justify-between p-4 xl:p-5 cursor-pointer seccion-titulo"
          [style.background]="expandedSections.has('vesUsdt') ? 'linear-gradient(135deg, #fff7ed, #ffedd5)' : 'white'">
          <div class="flex items-center gap-2 sm:gap-3 flex-wrap">
            <mat-icon style="color: #ea580c; font-size: 22px; width: 22px; height: 22px;">swap_vert</mat-icon>
            <span style="font-size: 1rem; font-weight: 700; color: #374151;">Tasa VES &rarr; USDT</span>
            <ng-container *ngIf="!vesUsdtConfig && loadingVesUsdt">
              <ng-container *ngTemplateOutlet="esqueletoPildora"></ng-container>
            </ng-container>
            <span *ngIf="vesUsdtConfig?.data?.tasaVigente && !hayTramosVesUsdt && !expandedSections.has('vesUsdt')"
              style="display: inline-flex; align-items: center; padding: 4px 12px; background: #fff7ed; border: 1px solid #fed7aa; border-radius: 20px; font-size: 0.8rem; font-weight: 800; color: #ea580c;">
              {{ vesUsdtConfig?.data?.tasaVigente?.tasaFinal | number:'1.2-2':'es-CL' }} VES
            </span>
            <span *ngIf="!expandedSections.has('vesUsdt') && alarmaDesvioVesUsdt" class="alarma-resumen">
              <mat-icon aria-hidden="true">trending_down</mat-icon>
              Desvío en contra: {{ desvioVesUsdt!.pct | number:'1.2-2':'es-CL' }} %
            </span>
            <span *ngIf="!expandedSections.has('vesUsdt')" class="resumen-seccion">{{ estadoDato(lastVesUsdtRefresh, 3) }} &middot; precios Binance en pausa</span>
            <span *ngIf="expandedSections.has('vesUsdt') && frescura(lastVesUsdtRefresh, 3) as fr" class="frescura" [class.frescura--vieja]="!fr.alDia">{{ fr.texto }}</span>
            <span *ngIf="hayTramosVesUsdt && !expandedSections.has('vesUsdt')"
              style="display: inline-flex; align-items: center; padding: 4px 12px; background: #fff7ed; border: 1px solid #fed7aa; border-radius: 20px; font-size: 0.8rem; font-weight: 800; color: #ea580c;">
              {{ listaTramosVesUsdt.length }} {{ listaTramosVesUsdt.length === 1 ? 'tramo' : 'tramos' }}
              &middot; {{ listaTramosVesUsdt[0].tasa | number:'1.2-2':'es-CL' }}<ng-container *ngIf="listaTramosVesUsdt.length > 1"> &rarr; {{ listaTramosVesUsdt[listaTramosVesUsdt.length - 1].tasa | number:'1.2-2':'es-CL' }}</ng-container> VES
            </span>
          </div>
          <mat-icon aria-hidden="true" style="color: #6b7280; transition: transform 0.3s ease; flex: 0 0 auto;"
            [style.transform]="expandedSections.has('vesUsdt') ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
        <div class="px-4 pb-4 xl:px-5 xl:pb-5"
          [class.hidden]="!expandedSections.has('vesUsdt')">

          <!-- Loading -->
          <ng-container *ngIf="loadingVesUsdt && !vesUsdtConfig">
            <ng-container *ngTemplateOutlet="esqueletoBloque"></ng-container>
          </ng-container>

          <div *ngIf="vesUsdtConfig">
            <ng-container *ngIf="hayTramosVesUsdt && tramosVesUsdt; else vesUsdtSinTramos">
              <!-- Tramos VES→USDT: lo que cobran las calculadoras según el monto -->
              <div style="display: flex; align-items: center; justify-content: flex-end; gap: 8px; margin-top: 8px; margin-bottom: 8px; flex-wrap: wrap;">
                <span style="display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; background: #ffedd5; border: 1px solid #fdba74; border-radius: 9999px; font-size: 0.68rem; font-weight: 800; letter-spacing: 0.5px; color: #9a3412;">
                  APLICADA
                </span>
                <span style="font-size: 0.7rem; color: #6b7280;">es la que cobran las calculadoras</span>
                <span *ngIf="lastVesUsdtRefresh" style="font-size: 0.7rem; color: #9ca3af;">&middot; le&iacute;da {{ hace(lastVesUsdtRefresh) }}</span>
                <button type="button" (click)="cargarVesUsdtConfig()" title="Actualizar ahora" aria-label="Actualizar ahora"
                  style="display: inline-flex; align-items: center; background: none; border: none; padding: 0; cursor: pointer; color: #ea580c;">
                  <mat-icon style="font-size: 15px; width: 15px; height: 15px;">refresh</mat-icon>
                </button>
              </div>

              <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 mb-4">
                <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 12px 14px;">
                  <p style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: #6b7280; font-weight: 700; margin-bottom: 4px;">Costo de mercado</p>
                  <p style="font-size: 1.35rem; font-weight: 800; color: #374151; line-height: 1.1;">
                    {{ tramosVesUsdt.referencia != null ? (tramosVesUsdt.referencia | number:'1.2-2':'es-CL') : '—' }}
                    <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">VES</span>
                  </p>
                  <p style="font-size: 0.72rem; color: #6b7280; margin-top: 4px;">Promedio 4 bancos (Binance)</p>
                </div>
                <div style="background: linear-gradient(135deg, #fff7ed, #ffedd5); border: 2px solid #fdba74; border-radius: 12px; padding: 12px 14px;">
                  <p style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: #ea580c; font-weight: 700; margin-bottom: 4px;">Tasa base &middot; tramo chico</p>
                  <p style="font-size: 1.35rem; font-weight: 800; color: #9a3412; line-height: 1.1;">
                    {{ tramosVesUsdt.base != null ? (tramosVesUsdt.base | number:'1.2-2':'es-CL') : '—' }}
                    <span style="font-size: 0.75rem; font-weight: 600; color: #ea580c;">VES</span>
                  </p>
                  <p style="font-size: 0.72rem; color: #6b7280; margin-top: 4px;">
                    Promedio + recargo {{ vesUsdtConfig.data.datosEnVivo.comisionConfigurada | number:'1.0-2':'es-CL' }} %
                    &middot; {{ vesUsdtConfig.data.tasaVigente?.modo === 'MANUAL_FIJO' ? 'manual fijo' : 'automático' }}
                  </p>
                </div>
                <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 12px 14px;">
                  <p style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: #6b7280; font-weight: 700; margin-bottom: 4px;">Margen m&iacute;nimo (candado)</p>
                  <p style="font-size: 1.35rem; font-weight: 800; color: #374151; line-height: 1.1; display: flex; align-items: center; gap: 4px;">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">lock</mat-icon>
                    {{ tramosVesUsdt.margenMinPct != null ? (tramosVesUsdt.margenMinPct | number:'1.2-2':'es-CL') + ' %' : '—' }}
                  </p>
                  <p style="font-size: 0.72rem; color: #6b7280; margin-top: 4px;">
                    Ning&uacute;n tramo baja de {{ pisoVesUsdt != null ? (pisoVesUsdt | number:'1.2-2':'es-CL') : '—' }}
                  </p>
                </div>
                <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 12px 14px;">
                  <p style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 0.5px; color: #16a34a; font-weight: 700; margin-bottom: 4px;">Espacio para descontar</p>
                  <p style="font-size: 1.35rem; font-weight: 800; color: #166534; line-height: 1.1;">
                    {{ espacioVesUsdt != null ? (espacioVesUsdt | number:'1.2-2':'es-CL') + ' %' : '—' }}
                  </p>
                  <p style="font-size: 0.72rem; color: #6b7280; margin-top: 4px;">Entre la tasa base y el candado</p>
                </div>
              </div>

              <!-- Tramos vigentes -->
              <p style="font-size: 0.8rem; font-weight: 800; color: #374151; margin-bottom: 6px;">Tramos vigentes</p>
              <div style="overflow-x: auto; border: 1px solid #e5e7eb; border-radius: 12px; margin-bottom: 6px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 0.8rem; min-width: 640px;">
                  <thead>
                    <tr style="background: #f9fafb; color: #374151; text-align: left;">
                      <th style="padding: 8px 10px; font-weight: 700;">Tramo</th>
                      <th style="padding: 8px 10px; font-weight: 700;">Desde &ndash; hasta</th>
                      <th style="padding: 8px 10px; font-weight: 700;">Modo</th>
                      <th style="padding: 8px 10px; font-weight: 700; text-align: right;">Tasa</th>
                      <th style="padding: 8px 10px; font-weight: 700; width: 30%;">Ganancia % sobre el costo</th>
                      <th style="padding: 8px 10px; font-weight: 700; text-align: right;">Cliente paga por 1.000 USDT</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let t of listaTramosVesUsdt; let i = index"
                      [style.background]="simVesUsdt?.indice === i ? '#fff7ed' : 'white'"
                      style="border-top: 1px solid #f3f4f6;">
                      <td style="padding: 8px 10px;">
                        <span style="display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px; border-radius: 9999px; background: #ffedd5; color: #9a3412; font-weight: 800;">{{ letraTramo(i) }}</span>
                      </td>
                      <td style="padding: 8px 10px; font-family: monospace; color: #374151; white-space: nowrap;">{{ rangoTramoVesUsdt(i) }}</td>
                      <td style="padding: 8px 10px;">
                        <span [style.background]="t.modo === 'PCT' ? '#fef3c7' : '#f3f4f6'"
                          [style.color]="t.modo === 'PCT' ? '#92400e' : '#374151'"
                          style="display: inline-block; padding: 2px 10px; border-radius: 9999px; font-size: 0.7rem; font-weight: 700; white-space: nowrap;">
                          {{ t.modo === 'PCT' ? 'Manual %' : 'Automático' }}
                        </span>
                      </td>
                      <td style="padding: 8px 10px; text-align: right; font-family: monospace; font-weight: 800; color: #9a3412; white-space: nowrap;">{{ t.tasa | number:'1.2-2':'es-CL' }}</td>
                      <td style="padding: 8px 10px;">
                        <div style="display: flex; align-items: center; gap: 8px;">
                          <div style="position: relative; flex: 1 1 auto; height: 10px; background: #f3f4f6; border-radius: 9999px;">
                            <div [style.width.%]="anchoMargenTramo(t)"
                              style="height: 100%; background: linear-gradient(90deg, #fdba74, #ea580c); border-radius: 9999px;"></div>
                            <div *ngIf="candadoVesUsdtPct != null" [style.left.%]="candadoVesUsdtPct"
                              title="Candado: margen m&iacute;nimo"
                              style="position: absolute; top: -3px; bottom: -3px; width: 2px; background: #374151;"></div>
                          </div>
                          <span style="font-family: monospace; font-weight: 700; color: #374151; white-space: nowrap; min-width: 56px; text-align: right;">{{ t.margenPct | number:'1.2-2':'es-CL' }} %</span>
                        </div>
                        <span *ngIf="t.recortado" style="display: block; font-size: 0.68rem; font-weight: 700; color: #92400e; margin-top: 2px;">
                          Recortado por la base, el piso o el tramo anterior
                        </span>
                      </td>
                      <td style="padding: 8px 10px; text-align: right; font-family: monospace; font-weight: 700; color: #374151; white-space: nowrap;">{{ t.tasa * 1000 | number:'1.0-0':'es-CL' }} VES</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p style="font-size: 0.72rem; color: #6b7280; margin-bottom: 14px; line-height: 1.5;">
                La barra mide el margen sobre el costo de mercado. La l&iacute;nea del candado es
                {{ tramosVesUsdt.margenMinPct != null ? (tramosVesUsdt.margenMinPct | number:'1.2-2':'es-CL') : '—' }} %:
                ninguna barra puede quedar m&aacute;s corta.
              </p>

              <!-- Simulador y últimos cambios -->
              <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
                <div style="background: #fff7ed; border: 1px solid #fed7aa; border-radius: 12px; padding: 14px;">
                  <p style="font-size: 0.8rem; font-weight: 800; color: #9a3412; margin-bottom: 8px;">Simulador</p>
                  <label for="sim-ves-usdt" style="display: block; font-size: 0.72rem; font-weight: 600; color: #6b7280; margin-bottom: 4px;">Monto en VES</label>
                  <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
                    <input id="sim-ves-usdt" type="number" min="1" step="10000" [(ngModel)]="simVesUsdtMonto"
                      style="flex: 1 1 auto; min-width: 0; height: 36px; padding: 0 10px; border: 1px solid #fdba74; border-radius: 8px; font-family: monospace; font-size: 0.9rem; background: white;" />
                    <span style="font-weight: 700; color: #374151;">VES</span>
                  </div>
                  <div *ngIf="simVesUsdt as s; else simVesUsdtVacio"
                    style="display: grid; grid-template-columns: auto 1fr; gap: 4px 12px; font-size: 0.8rem; align-items: center;">
                    <span style="color: #6b7280;">Tramo</span>
                    <span>
                      <span style="display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px; border-radius: 9999px; background: #ea580c; color: white; font-weight: 800; font-size: 0.75rem;">{{ letraTramo(s.indice) }}</span>
                      <span style="color: #6b7280; margin-left: 4px;">{{ rangoTramoVesUsdt(s.indice) }}</span>
                    </span>
                    <span style="color: #6b7280;">Tasa del tramo</span>
                    <b style="font-family: monospace; color: #9a3412;">{{ s.tasa | number:'1.2-2':'es-CL' }} VES</b>
                    <span style="color: #6b7280;">Recibe</span>
                    <b style="font-family: monospace; color: #374151; font-size: 0.95rem;">{{ s.recibe | number:'1.2-2':'es-CL' }} USDT</b>
                    <span style="color: #6b7280;">Con la tasa base recibir&iacute;a</span>
                    <span style="font-family: monospace; color: #374151;">{{ s.recibeBase | number:'1.2-2':'es-CL' }} USDT</span>
                    <span style="color: #6b7280;">Mejora para el cliente</span>
                    <b style="font-family: monospace; color: #166534;">+{{ s.mejoraUsdt | number:'1.2-2':'es-CL' }} USDT ({{ s.mejoraPct | number:'1.2-2':'es-CL' }} %)</b>
                    <span style="color: #6b7280;">Ganancia de Aguacate</span>
                    <span style="font-family: monospace; color: #374151;">
                      {{ s.margenPct | number:'1.2-2':'es-CL' }} %
                      <span *ngIf="s.margenVes != null" style="color: #6b7280;">(&asymp; {{ s.margenVes | number:'1.0-0':'es-CL' }} VES)</span>
                    </span>
                  </div>
                  <ng-template #simVesUsdtVacio>
                    <p style="font-size: 0.78rem; color: #6b7280;">Escribe un monto mayor que 0.</p>
                  </ng-template>
                </div>

                <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 14px;">
                  <p style="font-size: 0.8rem; font-weight: 800; color: #374151; margin-bottom: 8px;">&Uacute;ltimos cambios</p>
                  <p *ngIf="ultimosCambiosVesUsdt === undefined" style="font-size: 0.78rem; color: #6b7280;">Cargando&hellip;</p>
                  <p *ngIf="ultimosCambiosVesUsdt === null" style="font-size: 0.78rem; color: #6b7280;">No se pudo leer el historial.</p>
                  <p *ngIf="ultimosCambiosVesUsdt && !ultimosCambiosVesUsdt.length" style="font-size: 0.78rem; color: #6b7280;">Sin cambios registrados.</p>
                  <ul *ngIf="ultimosCambiosVesUsdt?.length" style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 8px;">
                    <li *ngFor="let h of ultimosCambiosVesUsdt" style="font-size: 0.78rem; line-height: 1.4; border-bottom: 1px dashed #e5e7eb; padding-bottom: 6px;">
                      <span style="font-family: monospace; color: #6b7280;">{{ h.createdAt | date:'dd/MM HH:mm' }}</span>
                      <span style="color: #374151; font-weight: 700;"> &middot; {{ h.editadoPor || '—' }}</span>
                      <span style="display: block; color: #374151;">
                        {{ etiquetaClaveTramo(h.clave) }} &middot; {{ h.accion }}<ng-container *ngIf="resumenCambioTramo(h) as r">: {{ r }}</ng-container>
                      </span>
                    </li>
                  </ul>
                  <!-- Ver: cualquier operador (abre en «Solo lectura» sin permiso) -->
                  <button type="button" (click)="abrirFranjas('VES-USDT')"
                    style="background: none; border: none; padding: 0; cursor: pointer; color: #ea580c; font-size: 0.78rem; font-weight: 700; text-decoration: underline;">
                    Ver historial completo
                  </button>
                </div>
              </div>

              <!-- Tasa fija manual (solo MANUAL_FIJO): pisa el tramo chico para todos -->
              <div *ngIf="avisoManualVesUsdt as aviso"
                style="display: flex; align-items: flex-start; gap: 8px; background: #fef3c7; border: 1px solid #fcd34d; border-radius: 12px; padding: 12px 14px; margin-bottom: 12px;">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #92400e; flex: 0 0 auto;">warning</mat-icon>
                <span style="font-size: 0.8rem; font-weight: 600; color: #92400e; line-height: 1.5;">{{ aviso }}</span>
              </div>
            </ng-container>

            <ng-template #vesUsdtSinTramos>
            <!-- Tasa vigente prominente (naranja) -->
            <div style="background: linear-gradient(135deg, #fff7ed, #ffedd5); border: 2px solid #fed7aa; border-radius: 14px; padding: 20px; margin-bottom: 12px; margin-top: 8px; text-align: center;">
              <p style="font-size: 0.7rem; text-transform: uppercase; letter-spacing: 1px; color: #ea580c; font-weight: 600; margin-bottom: 6px;">Tasa Vigente (Recargo)</p>
              <p style="font-size: 2.2rem; font-weight: 800; color: #9a3412; line-height: 1;">
                {{ vesUsdtConfig.data.tasaVigente?.tasaFinal | number:'1.2-2':'es-CL' }}
                <span style="font-size: 1rem; font-weight: 600; color: #ea580c;">VES</span>
              </p>
              <p style="font-size: 0.75rem; color: #6b7280; margin-top: 4px;">por 1 USDT (usuario paga m&aacute;s)</p>
              <div style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 8px; flex-wrap: wrap;">
                <span style="display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; background: #ffedd5; border: 1px solid #fdba74; border-radius: 9999px; font-size: 0.68rem; font-weight: 800; letter-spacing: 0.5px; color: #9a3412;">
                  APLICADA
                </span>
                <span style="font-size: 0.7rem; color: #6b7280;">es la que cobran las calculadoras</span>
                <span *ngIf="lastVesUsdtRefresh" style="font-size: 0.7rem; color: #9ca3af;">&middot; le&iacute;da {{ hace(lastVesUsdtRefresh) }}</span>
                <button type="button" (click)="cargarVesUsdtConfig()" title="Actualizar ahora" aria-label="Actualizar ahora"
                  style="display: inline-flex; align-items: center; background: none; border: none; padding: 0; cursor: pointer; color: #ea580c;">
                  <mat-icon style="font-size: 15px; width: 15px; height: 15px;">refresh</mat-icon>
                </button>
              </div>
              <div style="margin-top: 12px; padding-top: 10px; border-top: 1px dashed #fed7aa;">
                <p style="font-size: 0.85rem; color: #374151; line-height: 1.6;">
                  Binance <b style="font-weight: 700;">{{ vesUsdtConfig.data.datosEnVivo.promedioBinanceActual | number:'1.2-2':'es-CL' }}</b>
                  <span style="color: #6b7280;"> + recargo </span>
                  <b style="font-weight: 700; color: #ea580c;">{{ vesUsdtConfig.data.datosEnVivo.comisionConfigurada | number:'1.0-2':'es-CL' }} %</b>
                  <span style="color: #6b7280;"> = </span>
                  <b style="font-weight: 800; color: #9a3412;">{{ vesUsdtConfig.data.datosEnVivo.tasaFinalCalculada | number:'1.2-2':'es-CL' }} VES</b>
                </p>
                <p style="font-size: 0.7rem; color: #6b7280; margin-top: 2px;">
                  Esta cuenta se rehace cada vez que un cliente cotiza.
                </p>
              </div>
            </div>

            <!-- Modo activo -->
            <div *ngIf="vesUsdtConfig.data.tasaVigente" style="text-align: center; margin-bottom: 12px;">
              <span
                [style.background]="vesUsdtConfig.data.tasaVigente.modo === 'MANUAL_FIJO' ? '#fef3c7' : '#ffedd5'"
                [style.color]="vesUsdtConfig.data.tasaVigente.modo === 'MANUAL_FIJO' ? '#92400e' : '#9a3412'"
                style="display: inline-flex; align-items: center; gap: 4px; padding: 3px 12px; border-radius: 9999px; font-size: 0.72rem; font-weight: 700;">
                Modo activo: {{ vesUsdtConfig.data.tasaVigente.modo === 'MANUAL_FIJO' ? 'Precio manual fijo' : 'Automático por comisión %' }}
              </span>
            </div>
            </ng-template>

            <div *ngIf="!vesUsdtConfig.data.hayCambios"
              style="display: flex; align-items: center; justify-content: center; gap: 6px; margin-bottom: 12px;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">check_circle</mat-icon>
              <span style="font-size: 0.78rem; font-weight: 600; color: #166534;">
                Lo que se cobra es exactamente lo que dice el recargo configurado.
              </span>
            </div>

            <!-- Espejo del de arriba, con la lectura invertida: acá el cliente
                 PAGA bolívares, así que cobrar por debajo de la regla nos cuesta. -->
            <div *ngIf="vesUsdtConfig.data.hayCambios && desvioVesUsdt"
              [style.background]="desvioVesUsdt!.aFavor ? '#f0fdf4' : '#fef2f2'"
              [style.borderColor]="desvioVesUsdt!.aFavor ? '#bbf7d0' : '#fecaca'"
              style="border: 1px solid; border-radius: 12px; padding: 14px; margin-bottom: 12px;">

              <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
                <mat-icon [style.color]="desvioVesUsdt!.aFavor ? '#16a34a' : '#dc2626'"
                  style="font-size: 18px; width: 18px; height: 18px;">
                  {{ desvioVesUsdt!.aFavor ? 'trending_up' : 'trending_down' }}
                </mat-icon>
                <span [style.color]="desvioVesUsdt!.aFavor ? '#166534' : '#991b1b'"
                  style="font-size: 0.9rem; font-weight: 800;">
                  {{ desvioVesUsdt!.pct | number:'1.2-2':'es-CL' }} %
                  {{ desvioVesUsdt!.aFavor ? 'a favor de Aguacate' : 'en contra de Aguacate' }}
                </span>
              </div>

              <div style="display: grid; grid-template-columns: auto 1fr; gap: 4px 12px; font-size: 0.8rem; margin-bottom: 10px;">
                <span style="color: #6b7280;">Se cobra</span>
                <b style="color: #374151;">{{ desvioVesUsdt!.cobra | number:'1.2-2':'es-CL' }} VES</b>
                <span style="color: #6b7280;">La regla da</span>
                <b style="color: #374151;">{{ desvioVesUsdt!.regla | number:'1.2-2':'es-CL' }} VES</b>
                <span style="color: #6b7280;">Por 100 USDT</span>
                <b [style.color]="desvioVesUsdt!.aFavor ? '#166534' : '#991b1b'">
                  el cliente paga {{ desvioVesUsdt!.difPor100 | number:'1.0-0':'es-CL' }} VES
                  {{ desvioVesUsdt!.aFavor ? 'm&aacute;s' : 'menos' }}
                </b>
              </div>

              <p style="font-size: 0.72rem; color: #6b7280; margin-bottom: 10px; line-height: 1.5;">
                Con la tasa calcul&aacute;ndose al cotizar esto no deber&iacute;a pasar. Guard&aacute; para
                dejarlas parejas y avis&aacute; a desarrollo.
              </p>
              <button type="button" (click)="actualizarTasaVesUsdtAhora()"
                [disabled]="!puedeEditarTasas || loading || isUpdating"
                [style.opacity]="(!puedeEditarTasas || loading || isUpdating) ? '0.5' : '1'"
                [style.cursor]="(!puedeEditarTasas || loading || isUpdating) ? 'not-allowed' : 'pointer'"
                class="w-full sm:w-auto"
                style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 20px; background: #ea580c; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: background 0.2s ease;"
                onmouseover="this.style.background='#c2410c'" onmouseout="this.style.background='#ea580c'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">save</mat-icon>
                Guardar tasa en vivo
              </button>
            </div>

            <!-- Dónde está cada precio: Binance P2P, costo, base, tramos y el otro sentido -->
            <app-precio-binance-bloque direccion="VES-USDT" [activo]="expandedSections.has('vesUsdt')"
              [config]="vesUsdtConfig" [configContraria]="usdtVesConfig" [puedeEditar]="puedeEditarFranjas">
            </app-precio-binance-bloque>

            <!-- Con tramos: el editor de tramos y el modal de comisión de siempre (que también tiene la tasa fija) -->
            <div *ngIf="hayTramosVesUsdt" class="flex flex-col items-center gap-2">
              <div class="acciones-tasas acciones-tasas--centro">
                <button type="button" class="btn-tasas btn-tasas--ver" (click)="abrirFranjas('VES-USDT')">
                  <mat-icon aria-hidden="true">visibility</mat-icon>
                  Ver tramos e historial
                </button>
                <button type="button" class="btn-tasas btn-tasas--editar btn-tasas--naranja" (click)="abrirFranjas('VES-USDT')"
                  [disabled]="!puedeEditarFranjas" [attr.aria-describedby]="puedeEditarFranjas ? null : 'motivo-tramos-ves-usdt'">
                  <mat-icon aria-hidden="true">{{ puedeEditarFranjas ? 'stacked_bar_chart' : 'lock' }}</mat-icon>
                  Editar tramos
                </button>
                <span *ngIf="!puedeEditarFranjas" id="motivo-tramos-ves-usdt" class="motivo-sin-permiso">{{ textoSinPermisoTasas }}</span>
              </div>
              <div class="flex flex-col sm:flex-row justify-center gap-2 w-full sm:w-auto">
                <button type="button" (click)="abrirModalVesUsdt()"
                  [disabled]="!puedeEditarTasas || loading || isUpdating"
                  [style.opacity]="(!puedeEditarTasas || loading || isUpdating) ? '0.5' : '1'"
                  [style.cursor]="(!puedeEditarTasas || loading || isUpdating) ? 'not-allowed' : 'pointer'"
                  class="w-full sm:w-auto"
                  style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 9px 24px; background: white; color: #ea580c; border: 1px solid #ea580c; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                  onmouseover="this.style.background='#fff7ed'" onmouseout="this.style.background='white'">
                  <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #ea580c;">percent</mat-icon>
                  Configurar comisi&oacute;n base
                </button>
              </div>
            </div>

            <!-- Botón configurar -->
            <div *ngIf="!hayTramosVesUsdt" class="flex justify-center">
              <button type="button" (click)="abrirModalVesUsdt()"
                [disabled]="!puedeEditarTasas || loading || isUpdating"
                [style.opacity]="(!puedeEditarTasas || loading || isUpdating) ? '0.5' : '1'"
                [style.cursor]="(!puedeEditarTasas || loading || isUpdating) ? 'not-allowed' : 'pointer'"
                class="w-full sm:w-auto"
                style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 10px 28px; background: #ea580c; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                onmouseover="this.style.background='#c2410c'" onmouseout="this.style.background='#ea580c'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">settings</mat-icon>
                Configurar Comisi&oacute;n VES/USDT
              </button>
            </div>
          </div>

          <!-- Error VES-USDT -->
          <div *ngIf="errorVesUsdt"
            style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 12px; padding: 14px; text-align: center; margin-top: 8px;">
            <p style="font-size: 0.85rem; color: #dc2626; font-weight: 600; margin-bottom: 10px;">{{ errorVesUsdt }}</p>
            <button type="button" (click)="cargarVesUsdtConfig()"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 20px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: background 0.2s ease;"
              onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">refresh</mat-icon>
              Reintentar
            </button>
          </div>
        </div>
      </div>

      <!-- ══════════ Sección 5b: Tasas CLP ↔ USDT (tramos de compra y venta) ══════════ -->
      <!-- Sección propia (22/10/2026): antes los tramos CLP↔USDT solo se veían
           abriendo el modal «Tasas por monto» desde otra sección. Plegada no
           pide nada; al desplegarla lee los dos `/editor` (FRESCO_MS). -->
      <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden seccion-clp-usdt">
        <div (click)="toggleSection('clpUsdt')" role="button" tabindex="0"
          [attr.aria-expanded]="expandedSections.has('clpUsdt')"
          (keydown.enter)="toggleSectionTecla('clpUsdt', $event)" (keydown.space)="toggleSectionTecla('clpUsdt', $event)"
          class="flex items-center justify-between p-4 xl:p-5 cursor-pointer seccion-titulo"
          [style.background]="expandedSections.has('clpUsdt') ? 'linear-gradient(135deg, #f0fdfa, #ecfeff)' : 'white'">
          <div class="flex items-center gap-2 sm:gap-3 flex-wrap min-w-0">
            <mat-icon style="color: #0f766e; font-size: 22px; width: 22px; height: 22px;">currency_exchange</mat-icon>
            <span style="font-size: 1rem; font-weight: 700; color: #374151;">Tasas CLP &harr; USDT</span>
            <ng-container *ngIf="!expandedSections.has('clpUsdt')">
              <span *ngIf="resumenSeccionClp as r; else clpResumenSinLeer" class="resumen-seccion">
                {{ r }}<ng-container *ngIf="estadoDato(leidoClp, 3) as ed"> &middot; {{ ed }}</ng-container>
              </span>
              <ng-template #clpResumenSinLeer>
                <span class="resumen-seccion">Compra y venta por tramos &middot; se lee al abrir</span>
              </ng-template>
              <span *ngIf="hayAvisoClp" class="clp-aviso-resumen">
                <mat-icon aria-hidden="true">info</mat-icon>
                Tramos en la base
              </span>
            </ng-container>
            <span *ngIf="expandedSections.has('clpUsdt') && frescura(leidoClp, 3) as fr" class="frescura" [class.frescura--vieja]="!fr.alDia">{{ fr.texto }}</span>
          </div>
          <mat-icon aria-hidden="true" style="color: #6b7280; transition: transform 0.3s ease; flex: 0 0 auto;"
            [style.transform]="expandedSections.has('clpUsdt') ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
        <div class="px-4 pb-4 xl:px-5 xl:pb-5" [class.hidden]="!expandedSections.has('clpUsdt')">
          <div class="clp-bloques">
            <ng-container *ngFor="let par of paresClp">
              <ng-container *ngTemplateOutlet="bloqueClp; context: { $implicit: par }"></ng-container>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- ══════════ Sección 6: Pagos Venezuela (BP prioritario + N58 fallback) ══════════ -->
      <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden relative">
        <div (click)="toggleSection('pagosN58')" role="button" tabindex="0"
          [attr.aria-expanded]="expandedSections.has('pagosN58')"
          (keydown.enter)="toggleSectionTecla('pagosN58', $event)" (keydown.space)="toggleSectionTecla('pagosN58', $event)"
          class="flex items-center justify-between p-4 xl:p-5 cursor-pointer seccion-titulo"
          [style.background]="expandedSections.has('pagosN58') ? 'linear-gradient(135deg, #fef3c7, #fffbeb)' : 'white'">
          <div class="flex items-center gap-2 flex-wrap">
            <img src="assets/flags/venezuela.png" alt="Venezuela" style="width: 24px; height: 24px; border-radius: 50%; object-fit: cover; border: 1px solid #e5e7eb;">
            <span style="font-size: 1rem; font-weight: 700; color: #374151;">Pagos Venezuela</span>
            <span *ngIf="!expandedSections.has('pagosN58')" class="resumen-seccion">
              BP {{ bpPagosActivo ? 'activo' : 'apagado' }} &middot; N58 {{ n58PagosActivo ? 'activo' : 'apagado' }} &middot; R4 {{ r4PagosActivo ? 'activo' : 'apagado' }}
            </span>
          </div>
          <mat-icon aria-hidden="true" style="color: #6b7280; transition: transform 0.3s ease; flex: 0 0 auto;"
            [style.transform]="expandedSections.has('pagosN58') ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
        <div class="px-4 pb-4 xl:px-5 xl:pb-5"
          [class.hidden]="!expandedSections.has('pagosN58')">

          <!-- Toggle N58 -->
          <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 16px; margin-top: 8px;">
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 16px;">
              <div style="flex: 1;">
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;">
                  <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #f59e0b;">payments</mat-icon>
                  <span style="font-size: 0.9rem; font-weight: 700; color: #1f2937;">Pagos por N58</span>
                </div>
                <p style="font-size: 0.78rem; color: #6b7280; margin: 0;">
                  Envía retiros VES vía N58. Si BP también está activo, N58 actúa como fallback cuando BP no aplica (cuota agotada, monto fuera de rango BCV).
                </p>
              </div>
              <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                <mat-slide-toggle
                  [checked]="n58PagosActivo"
                  [disabled]="loadingN58Pagos"
                  (change)="toggleN58Pagos()"
                  color="primary">
                </mat-slide-toggle>
                <span style="font-size: 0.7rem; font-weight: 600;"
                  [style.color]="n58PagosActivo ? '#16a34a' : '#dc2626'">
                  {{ n58PagosActivo ? 'ON' : 'OFF' }}
                </span>
              </div>
            </div>

            <div *ngIf="loadingN58Pagos" style="display: flex; align-items: center; gap: 8px; margin-top: 12px; padding: 8px 12px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 8px;">
              <mat-spinner diameter="16"></mat-spinner>
              <span style="font-size: 0.78rem; color: #2563eb; font-weight: 600;">Actualizando estado...</span>
            </div>

            <div *ngIf="n58PagosError" style="display: flex; align-items: center; gap: 8px; margin-top: 12px; padding: 8px 12px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0;">error</mat-icon>
              <span style="font-size: 0.78rem; color: #dc2626; font-weight: 600;">{{ n58PagosError }}</span>
            </div>
          </div>

          <!-- Toggle Banco Plaza -->
          <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 16px; margin-top: 12px;">
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 16px;">
              <div style="flex: 1;">
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;">
                  <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #2563eb;">account_balance</mat-icon>
                  <span style="font-size: 0.9rem; font-weight: 700; color: #1f2937;">Pagos por Banco Plaza</span>
                </div>
                <p style="font-size: 0.78rem; color: #6b7280; margin: 0;">
                  Envía retiros VES vía Banco Plaza. Toma prioridad cuando cumple gates BCV (≤ 100 USD/op, ≤ 1000 USD/día); sino cae a N58 o manual.
                </p>
              </div>
              <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                <mat-slide-toggle
                  [checked]="bpPagosActivo"
                  [disabled]="loadingBPPagos"
                  (change)="toggleBPPagos()"
                  color="primary">
                </mat-slide-toggle>
                <span style="font-size: 0.7rem; font-weight: 600;"
                  [style.color]="bpPagosActivo ? '#16a34a' : '#dc2626'">
                  {{ bpPagosActivo ? 'ON' : 'OFF' }}
                </span>
              </div>
            </div>

            <div *ngIf="loadingBPPagos" style="display: flex; align-items: center; gap: 8px; margin-top: 12px; padding: 8px 12px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 8px;">
              <mat-spinner diameter="16"></mat-spinner>
              <span style="font-size: 0.78rem; color: #2563eb; font-weight: 600;">Actualizando estado...</span>
            </div>

            <div *ngIf="bpPagosError" style="display: flex; align-items: center; gap: 8px; margin-top: 12px; padding: 8px 12px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0;">error</mat-icon>
              <span style="font-size: 0.78rem; color: #dc2626; font-weight: 600;">{{ bpPagosError }}</span>
            </div>

          </div>

          <!-- Toggle R4 Conecta -->
          <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 16px; margin-top: 12px;">
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 16px;">
              <div style="flex: 1;">
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;">
                  <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #2563eb;">account_balance</mat-icon>
                  <span style="font-size: 0.9rem; font-weight: 700; color: #1f2937;">Pagos por R4 Conecta</span>
                </div>
                <p style="font-size: 0.78rem; color: #6b7280; margin: 0;">
                  Envía retiros VES vía R4 Conecta (Mi Banco). Fallback tras BP y N58. Si no hay fondos, el banco rechaza y se reembolsa.
                </p>
              </div>
              <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                <mat-slide-toggle
                  [checked]="r4PagosActivo"
                  [disabled]="loadingR4Pagos"
                  (change)="toggleR4Pagos()"
                  color="primary">
                </mat-slide-toggle>
                <span style="font-size: 0.7rem; font-weight: 600;"
                  [style.color]="r4PagosActivo ? '#16a34a' : '#dc2626'">
                  {{ r4PagosActivo ? 'ON' : 'OFF' }}
                </span>
              </div>
            </div>

            <div *ngIf="loadingR4Pagos" style="display: flex; align-items: center; gap: 8px; margin-top: 12px; padding: 8px 12px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 8px;">
              <mat-spinner diameter="16"></mat-spinner>
              <span style="font-size: 0.78rem; color: #2563eb; font-weight: 600;">Actualizando estado...</span>
            </div>

            <div *ngIf="r4PagosError" style="display: flex; align-items: center; gap: 8px; margin-top: 12px; padding: 8px 12px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0;">error</mat-icon>
              <span style="font-size: 0.78rem; color: #dc2626; font-weight: 600;">{{ r4PagosError }}</span>
            </div>

          </div>

          <!-- Info de regla -->
          <div style="display: flex; align-items: flex-start; gap: 8px; margin-top: 12px; padding: 10px 14px; background: #fffbeb; border: 1px solid #fde68a; border-radius: 10px;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #f59e0b; margin-top: 1px;">info</mat-icon>
            <span style="font-size: 0.75rem; color: #92400e; line-height: 1.4;">
              <strong>Regla:</strong> Banco Plaza tiene prioridad cuando cumple gates BCV (≤ 100 USD/op, ≤ 1000 USD/día acumulado). Si no aplica, cae a N58. Si ambos están apagados, los retiros VES van a manual (asignación maestra).
            </span>
          </div>
        </div>
      </div>

    </div>
  </ng-container>

  <!-- ══════════ Esqueletos de carga ══════════ -->
  <ng-template #esqueletoPildora>
    <span class="esqueleto esqueleto--pildora" aria-hidden="true"></span>
  </ng-template>

  <ng-template #esqueletoOperador>
    <div class="esqueleto-caja" role="status" aria-busy="true">
      <span class="solo-lector">Cargando operador activo&hellip;</span>
      <div class="esqueleto-fila" aria-hidden="true">
        <span class="esqueleto esqueleto--boton"></span>
        <span class="esqueleto esqueleto--boton"></span>
        <span class="esqueleto esqueleto--boton"></span>
      </div>
      <div class="esqueleto-fila" aria-hidden="true">
        <span class="esqueleto esqueleto--boton esqueleto--boton-ancho"></span>
        <span class="esqueleto esqueleto--boton esqueleto--boton-ancho"></span>
      </div>
    </div>
  </ng-template>

  <ng-template #esqueletoBancos>
    <div class="esqueleto-caja" role="status" aria-busy="true">
      <span class="solo-lector">Cargando bancos&hellip;</span>
      <div class="esqueleto-fila esqueleto-fila--inicio" aria-hidden="true">
        <span class="esqueleto esqueleto--pildora esqueleto--pildora-ancha"></span>
        <span class="esqueleto esqueleto--pildora esqueleto--pildora-ancha"></span>
        <span class="esqueleto esqueleto--pildora"></span>
      </div>
      <div class="esqueleto-grilla esqueleto-grilla--4" aria-hidden="true">
        <span class="esqueleto esqueleto--tarjeta"></span>
        <span class="esqueleto esqueleto--tarjeta"></span>
        <span class="esqueleto esqueleto--tarjeta"></span>
        <span class="esqueleto esqueleto--tarjeta"></span>
      </div>
      <div class="esqueleto-grilla esqueleto-grilla--2" aria-hidden="true">
        <span class="esqueleto esqueleto--tarjeta esqueleto--tarjeta-baja"></span>
        <span class="esqueleto esqueleto--tarjeta esqueleto--tarjeta-baja"></span>
      </div>
    </div>
  </ng-template>

  <!-- Tarjetas de tasas: tres por defecto (o las que se pidan) -->
  <ng-template #esqueletoTarjetas let-n>
    <div class="esqueleto-caja" role="status" aria-busy="true">
      <span class="solo-lector">Cargando tasas&hellip;</span>
      <div class="esqueleto-grilla" [class.esqueleto-grilla--2]="n === 2" aria-hidden="true">
        <span class="esqueleto esqueleto--tarjeta"></span>
        <span class="esqueleto esqueleto--tarjeta"></span>
        <span *ngIf="n !== 2" class="esqueleto esqueleto--tarjeta"></span>
      </div>
    </div>
  </ng-template>

  <ng-template #esqueletoBloque>
    <div class="esqueleto-caja" role="status" aria-busy="true">
      <span class="solo-lector">Cargando tasa&hellip;</span>
      <span class="esqueleto esqueleto--bloque" aria-hidden="true"></span>
      <div class="esqueleto-fila" aria-hidden="true">
        <span class="esqueleto esqueleto--pildora esqueleto--pildora-ancha"></span>
      </div>
      <div class="esqueleto-fila" aria-hidden="true">
        <span class="esqueleto esqueleto--boton esqueleto--boton-ancho"></span>
      </div>
    </div>
  </ng-template>

  <!-- ══════════ Bloque de la sección «Tasas CLP ↔ USDT» (compra o venta) ══════════ -->
  <ng-template #bloqueClp let-par>
    <section class="clp-bloque" [class.clp-bloque--venta]="par === 'USDT-CLP'" [attr.data-par]="par"
      [attr.aria-labelledby]="'clp-titulo-' + par">
      <div class="clp-bloque__cabecera">
        <h3 class="clp-bloque__titulo" [id]="'clp-titulo-' + par">
          {{ par === 'CLP-USDT' ? 'Compra' : 'Venta' }}
          <span class="clp-bloque__sentido">{{ par === 'CLP-USDT' ? 'CLP → USDT' : 'USDT → CLP' }}</span>
        </h3>
        <p class="clp-bloque__bajada">
          {{ par === 'CLP-USDT'
            ? 'El cliente paga CLP por cada USDT. Los tramos bajan la tasa hasta el piso.'
            : 'El cliente recibe CLP por cada USDT. Los tramos suben la tasa hasta el techo.' }}
        </p>
      </div>

      <!-- Modelo de distancia (Oscar, 23/10): el bloque «Lo que cotiza el motor ahora» reemplaza
           los KPI del margen mínimo y el tope. Con la API vieja no pinta nada y todo sigue igual. -->
      <app-distancia-bloque [ruta]="par" [activo]="expandedSections.has('clpUsdt')" [puedeEditar]="puedeEditarFranjas" [recarga]="recargaDe(par)"
        (modelo)="ponerDistanciaClp(par, $event)" (guardado)="cargarTramosClp(par)">
      </app-distancia-bloque>

      <!-- Con datos -->
      <ng-container *ngIf="vistaDe(par) as v; else clpSinVista">
        <div class="clp-kpis" *ngIf="!esDistanciaClp(par)">
          <div class="clp-kpi clp-kpi--base">
            <p class="clp-kpi__etiqueta">Tasa base</p>
            <p class="clp-kpi__valor">{{ v.base != null ? (v.base | number:'1.2-2':'es-CL') : '—' }}</p>
            <p class="clp-kpi__nota">{{ v.esVenta ? 'la más baja: tramo chico' : 'la más alta: tramo chico' }}</p>
          </div>
          <div class="clp-kpi">
            <p class="clp-kpi__etiqueta">Spot USD/CLP</p>
            <p class="clp-kpi__valor">{{ v.referencia != null ? (v.referencia | number:'1.2-2':'es-CL') : '—' }}</p>
            <p class="clp-kpi__nota">referencia</p>
          </div>
          <div class="clp-kpi">
            <p class="clp-kpi__etiqueta">{{ v.esVenta ? 'Techo' : 'Piso' }}</p>
            <p class="clp-kpi__valor">{{ v.limite != null ? (v.limite | number:'1.2-2':'es-CL') : '—' }}</p>
            <p class="clp-kpi__nota">{{ v.esVenta ? 'ningún tramo paga más' : 'ningún tramo cobra menos' }}</p>
          </div>
          <div class="clp-kpi">
            <p class="clp-kpi__etiqueta">Margen mínimo</p>
            <p class="clp-kpi__valor">{{ v.margenMinPct != null ? (v.margenMinPct | number:'1.2-2':'es-CL') + ' %' : '—' }}</p>
            <p class="clp-kpi__nota">{{ v.esVenta ? 'bajo el spot' : 'sobre el spot' }}</p>
          </div>
          <div class="clp-kpi">
            <p class="clp-kpi__etiqueta">Tope</p>
            <p class="clp-kpi__valor">{{ v.topePct != null ? (v.topePct | number:'1.2-2':'es-CL') + ' %' : '—' }}</p>
            <p class="clp-kpi__nota">mejora máxima sobre la base</p>
          </div>
        </div>

        <p *ngIf="v.esVenta && !esDistanciaClp(par)" class="clp-nota">
          Compra m&aacute;s baja: <b>{{ v.compraMinFinal != null ? (v.compraMinFinal | number:'1.2-2':'es-CL') : '—' }}</b>
          &middot; el techo no pasa de ella &divide; 1,005.
        </p>
        <p *ngIf="!v.esVenta && v.baseVenta != null && !esDistanciaClp(par)" class="clp-nota">
          Venta base: <b>{{ v.baseVenta | number:'1.2-2':'es-CL' }}</b>
          &middot; el piso no baja de ella + 0,5 %.
        </p>

        <!-- Por qué no hay tramos (motivo del back o todos en la base) -->
        <div *ngIf="v.aviso && !esDistanciaClp(par)" class="clp-aviso" role="note">
          <mat-icon aria-hidden="true">info</mat-icon>
          <span>{{ v.aviso }}</span>
        </div>

        <!-- Tramos -->
        <ng-container *ngIf="v.tasas.length">
          <p class="clp-subtitulo">Tramos</p>
          <div class="clp-tabla-caja">
            <table class="clp-tabla">
              <thead>
                <tr>
                  <th scope="col">Tramo</th>
                  <th scope="col">Desde &ndash; hasta</th>
                  <th scope="col" class="clp-num">Tasa</th>
                  <th scope="col" class="clp-num">Mejora</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let t of v.tasas; let i = index" [class.clp-fila--sim]="simClp(par)?.indice === i">
                  <td><span class="clp-letra">{{ letraTramo(i) }}</span></td>
                  <td class="clp-rango">{{ rangoClp(par, i) }}</td>
                  <td class="clp-num clp-tasa">{{ t.tasa | number:'1.2-2':'es-CL' }}</td>
                  <td class="clp-num">
                    {{ t.mejoraPct > 0 ? '+' : '' }}{{ t.mejoraPct | number:'1.2-2':'es-CL' }} %
                    <span *ngIf="t.recortado" class="clp-recortado">recortado</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p *ngIf="v.publicados != null && v.publicados !== v.tasas.length" class="clp-nota">
            Hoy se cobran {{ v.publicados }} {{ v.publicados === 1 ? 'tramo' : 'tramos' }}: lo editado rige desde la pr&oacute;xima tasa base.
          </p>

          <!-- Simulador -->
          <div class="clp-sim">
            <label class="clp-sim__etiqueta" [attr.for]="'sim-' + par">{{ v.esVenta ? 'Simular una venta, en USDT' : 'Simular una compra, en CLP' }}</label>
            <div class="clp-sim__entrada">
              <input [id]="'sim-' + par" type="number" min="1" inputmode="decimal"
                [step]="v.esVenta ? 100 : 100000" [ngModel]="montoSimDe(par)" (ngModelChange)="ponerMontoSim(par, $event)" />
              <span>{{ v.esVenta ? 'USDT' : 'CLP' }}</span>
            </div>
            <div *ngIf="simClp(par) as s; else clpSimVacio" class="clp-sim__resultado">
              <span>Tramo</span>
              <span><span class="clp-letra clp-letra--activa">{{ letraTramo(s.indice) }}</span> {{ rangoClp(par, s.indice) }}</span>
              <span>Tasa</span>
              <b class="clp-tasa">{{ s.tasa | number:'1.2-2':'es-CL' }} CLP</b>
              <span>Recibe</span>
              <b>{{ s.recibe | number:'1.2-2':'es-CL' }} {{ v.esVenta ? 'CLP' : 'USDT' }}</b>
              <span>Con la base</span>
              <span>{{ s.recibeBase | number:'1.2-2':'es-CL' }} {{ v.esVenta ? 'CLP' : 'USDT' }}</span>
              <span>Mejora</span>
              <b class="clp-mejora">+{{ s.mejora | number:'1.2-2':'es-CL' }} {{ v.esVenta ? 'CLP' : 'USDT' }} ({{ s.mejoraPct | number:'1.2-2':'es-CL' }} %)</b>
            </div>
            <ng-template #clpSimVacio>
              <p class="clp-nota">Escribe un monto mayor que 0.</p>
            </ng-template>
          </div>
        </ng-container>
      </ng-container>

      <!-- Sin datos: esqueleto, no disponible o error -->
      <ng-template #clpSinVista>
        <ng-container *ngIf="cargaDe(par).cargando; else clpSinVistaQuieta">
          <ng-container *ngTemplateOutlet="esqueletoBloque"></ng-container>
        </ng-container>
        <ng-template #clpSinVistaQuieta>
          <div *ngIf="cargaDe(par).noDisponible" class="clp-no-disponible" role="status">
            <mat-icon aria-hidden="true">cloud_off</mat-icon>
            <div>
              <p class="clp-no-disponible__titulo">Tramos no disponibles</p>
              <p>El servidor todav&iacute;a no tiene los tramos {{ par === 'CLP-USDT' ? 'CLP → USDT' : 'USDT → CLP' }}. Se cobra la tasa de siempre.</p>
            </div>
          </div>
          <div *ngIf="cargaDe(par).error as err" class="clp-error" role="alert">
            <p>{{ err }}</p>
            <button type="button" class="btn-tasas btn-tasas--ver" (click)="cargarTramosClp(par)">
              <mat-icon aria-hidden="true">refresh</mat-icon>
              Reintentar
            </button>
          </div>
        </ng-template>
      </ng-template>

      <!-- Ver: cualquier operador (sin permiso abre en «Solo lectura»). Editar: solo los encargados. -->
      <div *ngIf="!cargaDe(par).noDisponible" class="acciones-tasas clp-acciones">
        <button type="button" class="btn-tasas btn-tasas--ver" [attr.data-accion]="'ver-' + par" (click)="abrirFranjas(par)">
          <mat-icon aria-hidden="true">visibility</mat-icon>
          Ver tramos
        </button>
        <button type="button" class="btn-tasas btn-tasas--editar" [attr.data-accion]="'editar-' + par" (click)="abrirFranjas(par)"
          [disabled]="!puedeEditarFranjas" [attr.aria-describedby]="puedeEditarFranjas ? null : 'motivo-tramos-' + par">
          <mat-icon aria-hidden="true">{{ puedeEditarFranjas ? 'stacked_bar_chart' : 'lock' }}</mat-icon>
          Editar tramos
        </button>
        <span *ngIf="!puedeEditarFranjas" [id]="'motivo-tramos-' + par" class="motivo-sin-permiso">{{ textoSinPermisoTasas }}</span>
      </div>
    </section>
  </ng-template>

  <!-- Estado inicial -->
  <div *ngIf="!valoresFrontend && !loading && !error" class="flex justify-center py-8">
    <p style="font-size: 0.9rem; color: #6b7280;">Cargando valores del sistema...</p>
  </div>

</div>
